import { jsxs as l, jsx as n, Fragment as _ } from "react/jsx-runtime";
import { useQuery as Jt, useIsFetching as pr, useInfiniteQuery as Wt, QueryClient as mr, QueryClientProvider as gr } from "@tanstack/react-query";
import { signInWithEmailAndPassword as vr, signOut as fr, onAuthStateChanged as yr } from "firebase/auth";
import { useSelector as P, useDispatch as Sr, Provider as Pr } from "react-redux";
import { createAsyncThunk as te, createSelector as br, createSlice as ne, configureStore as Cr } from "@reduxjs/toolkit";
import { useMemo as T, StrictMode as wr, useEffect as F, useCallback as Ae, useState as S, useLayoutEffect as Ir, createContext as me, useContext as ge, useRef as ve, forwardRef as kr, Fragment as Nr } from "react";
import { useNavigate as H, RouterProvider as Ar, useMatches as st, useSubmit as it, Link as lt, useNavigation as Er, useBlocker as Mr, Outlet as le, redirect as U, NavLink as Lr, useParams as Ur, useLoaderData as $r, Form as jr, useRouteError as Dr, createBrowserRouter as xr, Navigate as Br } from "react-router-dom";
import { Button as f, usePortalContainer as Xt, Avatar as Zt, Image as ct, PresetCard as _r, PresetCardSkeleton as Tr, SelectSkeleton as Te, ButtonSkeleton as Or, IconButtonSkeleton as Rr, Select as R, Input as ce, IconButton as dt, spacing as en, theme as q, mixInTransparency as He, Separator as Fr, DropdownContainer as Hr, IndeterminatePlaceholder as Kr, Overlay as tn, Dialog as nn, DialogTitle as rn, DialogActions as on, SelectField as be, Switch as Z, GroupField as Ke, SelectFieldSkeleton as ze, SplitButton as zr, InputField as At, PortalContext as Qr } from "@electra-one/components";
import { TimeoutError as Gr, ElectraMidiCommunication as Vr, CommunicationContext as qr } from "@electra-one/communication";
import { useConfig as an, ConfigContext as Yr } from "@electra-one/config";
import { parseMidiMessage as sn } from "@electra-one/midi";
import { createPortal as Ce } from "react-dom";
import { AlertCircle as Jr, X as ln, ChevronsUp as Wr, ChevronsDown as Xr, List as Zr, Grid as eo, Loader as cn, FileText as to, Cloud as no, Settings as ro, Info as oo, Terminal as ut, ExternalLink as Ee, Menu as ao, ArrowLeft as so, Eye as io, EyeOff as lo } from "react-feather";
import co from "@react-hook/resize-observer";
import { VList as dn } from "virtua";
import { makeChunks as uo, useDebounce as ho, saveFileAs as ie } from "@electra-one/utils";
import L from "classnames";
import { DateTime as we } from "luxon";
import po from "react-markdown";
import { LuaConsole as mo, MidiConsole as go, formatAs8BitHex as vo } from "@electra-one/console";
const fo = (e, t) => {
  const r = t.payload;
  e.electras[r].logs = [];
}, yo = (e, t) => {
  const [r, o, a] = t.payload, { index: s } = e.electras[r].presets;
  s === void 0 || s[o] === void 0 || (s[o][a] = void 0);
}, So = (e, t) => {
  const [r, o, a, s, i] = t.payload, { index: c } = e.electras[r].presets;
  c === void 0 || c[o] === void 0 || (c[o][a] = {
    bankNumber: o,
    slot: a,
    name: i,
    projectId: s
  });
}, Po = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].presets.activeBank = o;
}, bo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].presets.activeSlot = o;
}, Co = (e, t, r) => {
  e.electras[t].presets.index = {};
  const { index: o } = e.electras[t].presets;
  for (const a of r) {
    const { bankNumber: s, slot: i } = a;
    o[s] === void 0 && (o[s] = {}), o[s][i] = a;
  }
}, wo = (e, t) => {
  e.activeElectra = t.payload;
}, Io = (e, t) => {
  e.discoveryPending = t.payload;
}, ko = {
  index: {},
  activeBank: 0,
  activeSlot: -1
}, G = [
  "FFFFFF",
  "F45C51",
  "F49500",
  "529DEC",
  "03A598",
  "C44795"
], V = {
  saved: !1,
  router: {
    usbDevToMidiIo: !1,
    usbDevToUsbHost: !1,
    midiIoToUsbDev: !1,
    midiIoToUsbHost: !1,
    usbHostToMidiIo: !1,
    usbHostToUsbDev: !1,
    midiIo1Thru: !1,
    midiIo2Thru: !1,
    midiControlInterface: "usbDev",
    midiControlPort: 2,
    midiControlChannel: 0,
    midiControlDrop: !0,
    usbDevToMidiControl: !0
  },
  midiControl: [],
  usbHostAssignments: [],
  ui: {
    activeControlSetType: "dim",
    touchSwitchControlSets: !0,
    resetActiveControlSet: !1,
    keepPresetState: !1,
    loadPresetStateOnStartup: !1
  },
  presetBanks: [
    {
      id: 1,
      name: "BANK #1",
      color: G[0]
    },
    {
      id: 2,
      name: "BANK #2",
      color: G[1]
    },
    {
      id: 3,
      name: "BANK #3",
      color: G[2]
    },
    {
      id: 4,
      name: "BANK #4",
      color: G[3]
    },
    {
      id: 5,
      name: "BANK #5",
      color: G[4]
    },
    {
      id: 6,
      name: "BANK #6",
      color: G[5]
    }
  ]
}, No = (e, t) => {
  if (e.activeElectra !== -1) {
    const r = e.electras[e.activeElectra].serial;
    e.activeElectra = t.payload.findIndex(
      (o) => o.serial === r
    );
  }
  e.electras = t.payload.map((r) => ({
    ...r,
    settings: V,
    presets: ko,
    logs: []
  }));
}, Ao = (e, t) => {
  [e.inputPorts, e.outputPorts] = t.payload;
}, Eo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.midiControl.push(o);
}, Mo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.usbHostAssignments.push(o);
}, Lo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.midiControl.splice(o, 1);
}, Uo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.usbHostAssignments.splice(
    o,
    1
  );
}, $o = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.presetBanks[o] = V.presetBanks[o];
}, jo = (e, t) => {
  const [r, [o, a]] = t.payload;
  if (o >= e.electras[r].settings.midiControl.length)
    throw new Error(`midi control mapping index '${o}' out of bounds`);
  e.electras[r].settings.saved = !1, e.electras[r].settings.midiControl[o] = a;
}, Do = (e, t) => {
  const [r, o, a] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.presetBanks[o] = a;
}, xo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.router = o;
}, Bo = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = o;
}, _o = (e, t, r) => {
  r !== null && (e.electras[t].settings.saved = !0, e.electras[t].settings.router = r.router ?? V.router, e.electras[t].settings.midiControl = r.midiControl ?? V.midiControl, e.electras[t].settings.usbHostAssignments = r.usbHostAssigments ?? V.usbHostAssignments, e.electras[t].settings.ui = {
    ...V.ui,
    ...r.uiFeatures
  }, e.electras[t].settings.presetBanks = V.presetBanks.map(
    (o, a) => {
      var s;
      return ((s = r.presetBanks) == null ? void 0 : s[a]) ?? o;
    }
  ));
}, To = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.ui = o;
}, Oo = (e, t) => {
  const [r, [o, a]] = t.payload;
  e.electras[r].settings.saved = !1, e.electras[r].settings.usbHostAssignments[o] = a;
}, Ro = (e, t) => {
  const [r, o] = t.payload;
  e.electras[r].logs.push(...o);
}, Qe = te(
  "hardware/getPresetList",
  ({ communication: e, input: t, output: r }) => e.getPresetList(t, r, 1e3)
), ht = te(
  "hardware/getConfiguration",
  ({ communication: e, input: t, output: r }) => e.getElectraConfiguration(t, r, 1e3)
), fe = (e) => e.hardware, Fo = (e) => fe(e).discoveryPending, un = (e) => fe(e).inputPorts, hn = (e) => fe(e).outputPorts, Me = (e) => fe(e).electras, z = (e) => fe(e).activeElectra, J = (e) => {
  const t = Me(e), r = z(e);
  return r === -1 ? null : t[r];
}, ee = (e) => {
  const t = J(e);
  if (t === null)
    throw new Error("no active electra selected");
  if (t.ctrl.input === null || t.ctrl.output === null)
    throw new Error("missing ctrl ports");
  return [t.ctrl.input, t.ctrl.output];
}, re = (e) => {
  const t = J(e);
  if (t === null)
    throw new Error("no active electra selected");
  return t.settings;
}, Ho = (e) => re(e).saved, pn = (e) => re(e).router, mn = (e) => re(e).midiControl, gn = (e) => re(e).usbHostAssignments, vn = (e) => re(e).ui, fn = (e) => re(e).presetBanks, Ko = (e) => {
  const t = J(e);
  return t === null ? null : t.presets;
}, de = (e) => {
  const t = Ko(e);
  if (t === null)
    throw new Error("no active electra selected");
  return t;
}, yn = br(
  J,
  (e) => e === null ? [] : e.logs
), zo = () => P(Ho), Sn = () => P(pn), Qo = () => P(mn), Go = () => P(gn), Vo = () => P(vn), pt = () => P(fn), Pn = () => P(de).index, bn = () => P(de).activeBank, Cn = () => P(de).activeSlot, mt = () => P(Fo), O = () => P(z), qo = () => {
  const e = P(J);
  if (e === null)
    throw new Error("no active electra");
  return e;
}, Yo = () => P(Me), oe = () => P(z) !== -1, wn = () => P(un), In = () => P(hn), Jo = (e) => {
  const t = wn();
  return T(() => t.find((r) => r.id === e), [e, t]);
}, Wo = (e) => {
  const t = In();
  return T(() => t.find((r) => r.id === e), [e, t]);
}, Xo = () => P(yn), Zo = {
  discoveryPending: !1,
  inputPorts: [],
  outputPorts: [],
  electras: [],
  activeElectra: -1
}, Ge = ne({
  name: "hardware",
  initialState: Zo,
  reducers: {
    setDiscoveryPending: Io,
    setPorts: Ao,
    setElectras: No,
    setActiveElectra: wo,
    setSettingsSaved: Bo,
    setRouterState: xo,
    setMidiControlMapping: jo,
    createMidiControlMapping: Eo,
    deleteMidiControlMapping: Lo,
    setUsbHostAssignment: Oo,
    createUsbHostAssignment: Mo,
    deleteUsbHostAssignment: Uo,
    setUiState: To,
    setPresetBankState: Do,
    resetPresetBank: $o,
    setActiveBank: Po,
    setActiveSlot: bo,
    clearPresetSlot: yo,
    patchPresetSlot: So,
    storeLogs: Ro,
    clearLogs: fo
  },
  extraReducers: (e) => {
    e.addCase(Qe.fulfilled, (t, r) => {
      Co(t, r.meta.arg.index, r.payload);
    }), e.addCase(ht.fulfilled, (t, r) => {
      _o(t, r.meta.arg.index, r.payload);
    });
  }
}), {
  setDiscoveryPending: Et,
  setPorts: Oe,
  setElectras: ea,
  setActiveElectra: kn,
  setSettingsSaved: ta,
  setRouterState: x,
  setMidiControlMapping: Pe,
  createMidiControlMapping: na,
  deleteMidiControlMapping: ra,
  setUsbHostAssignment: Mt,
  createUsbHostAssignment: oa,
  deleteUsbHostAssignment: aa,
  setUiState: ae,
  setPresetBankState: Lt,
  resetPresetBank: sa,
  setActiveBank: Ut,
  setActiveSlot: Ve,
  clearPresetSlot: ia,
  patchPresetSlot: la,
  storeLogs: ca,
  clearLogs: da
} = Ge.actions, Nn = te(
  "midiConsole/openInputPort",
  ({ communication: e, id: t }) => e.openInput(t, 1e3)
), An = te(
  "midiConsole/openOutputPort",
  ({ communication: e, id: t }) => e.openOutput(t, 1e3)
), En = te(
  "midiConsole/closeInputPort",
  ({ communication: e, id: t }) => e.closeInput(t, 1e3)
), Mn = te(
  "midiConsole/closeOutputPort",
  ({ communication: e, id: t }) => e.closeOutput(t, 1e3)
), gt = (e) => e.midiConsole, vt = (e) => gt(e).inputPortMap, qe = (e) => gt(e).outputPort, Ln = (e) => gt(e).messages, ua = () => P(vt), ha = () => P(qe), pa = () => P(Ln), ma = {
  inputPortMap: {
    1: null,
    2: null,
    3: null
  },
  outputPort: null,
  messages: []
}, Ye = ne({
  name: "midiConsole",
  initialState: ma,
  reducers: {
    storeMessages: (e, t) => {
      e.messages.push(...t.payload);
    },
    clearMessages: (e) => {
      e.messages = [];
    }
  },
  extraReducers: (e) => {
    e.addCase(Nn.fulfilled, (t, r) => {
      t.inputPortMap[r.meta.arg.portCode] = r.meta.arg.id;
    }), e.addCase(An.fulfilled, (t, r) => {
      t.outputPort = r.meta.arg.id;
    }), e.addCase(En.fulfilled, (t, r) => {
      delete t.inputPortMap[r.meta.arg.portCode];
    }), e.addCase(Mn.fulfilled, (t) => {
      t.outputPort = null;
    });
  }
}), { storeMessages: Un, clearMessages: ga } = Ye.actions, $n = ({
  fallback: e,
  children: t
}) => Aa() ? typeof e == "function" ? e() : e : t;
var va = "s1bxr10", fa = "s1bxr11", ya = "s1bxr12", Sa = "s1bxr13";
const Pa = ({ children: e }) => {
  const t = H();
  return /* @__PURE__ */ l("div", { className: va, children: [
    e != null && /* @__PURE__ */ n("div", { className: fa, children: e }),
    /* @__PURE__ */ n("div", { className: ya, children: /* @__PURE__ */ l("div", { className: Sa, children: [
      /* @__PURE__ */ n("span", { children: "You need to be logged in to see this page." }),
      /* @__PURE__ */ n(f, { onClick: () => t("/login"), children: "Go to Login page" })
    ] }) })
  ] });
}, ba = ({
  fallback: e,
  children: t
}) => {
  const r = Le(), o = typeof e == "function" ? e() : e;
  return /* @__PURE__ */ n($n, { fallback: o, children: r === null ? /* @__PURE__ */ n(Pa, { children: o }) : t });
}, Ca = {
  loggedInUser: null,
  actionPending: !1
}, Je = ne({
  name: "user",
  initialState: Ca,
  reducers: {
    setUser: (e, t) => {
      e.loggedInUser = t.payload;
    },
    clearUser: (e) => {
      e.loggedInUser = null;
    },
    setActionPending: (e, t) => {
      e.actionPending = t.payload;
    }
  }
}), { setUser: wa, clearUser: Ia, setActionPending: $t } = Je.actions, jn = (e) => e.user, ye = (e) => jn(e).loggedInUser, We = (e) => {
  const t = ye(e);
  if (t === null)
    throw new Error("user not logged in");
  return t;
}, ka = (e) => jn(e).actionPending, Le = () => P(ye), Na = () => P(We), Aa = () => P(ka), Ea = ({ router: e }) => /* @__PURE__ */ n(wr, { children: /* @__PURE__ */ n(Ar, { router: e }) });
let Xe;
const Dn = () => {
  if (Xe === void 0)
    throw new Error("Auth not initialized, call initializeElectraAuth");
  return Xe;
}, Ma = (e) => Xe = e, B = (e, t) => {
  const r = [];
  for (let o = 0; o < e; o++)
    r.push(t(o));
  return r;
};
var $ = /* @__PURE__ */ ((e) => (e.PublicProjects = "public-projects", e.PrivateProjects = "private-projects", e.ControllerSettings = "controller-settings", e.ControllerInfo = "controller-info", e.LuaConsole = "lua-console", e.MidiConsole = "midi-console", e.Login = "login", e))($ || {});
const La = () => {
  const e = st();
  return T(
    () => [
      "private-projects",
      "public-projects",
      "controller-settings",
      "controller-info",
      "lua-console",
      "midi-console",
      "login"
      /* Login */
    ].find((t) => e.some((r) => r.id === t)) ?? null,
    [e]
  );
}, jt = "E1", W = (e) => {
  F(() => (window.document.title = `${jt} | ${e}`, () => {
    window.document.title = jt;
  }), [e]);
}, Ua = (e) => e.error, $a = (e) => Ua(e).errors, ja = () => P($a), Da = {
  errors: []
}, xn = 1e3 * 30, Ze = ne({
  name: "error",
  initialState: Da,
  reducers: {
    pushError: (e, t) => {
      e.errors.push({
        createdAt: Date.now(),
        message: t.payload
      });
    },
    clearOldErrors: (e) => {
      const t = Date.now();
      e.errors = e.errors.filter(
        (r) => t - r.createdAt < xn
      );
    },
    removeErrorAtIndex: (e, t) => {
      e.errors.splice(t.payload, 1);
    }
  }
}), xa = {
  uiFilter: {
    brand: null,
    group: null,
    type: null,
    search: null
  },
  storageFilter: {
    brand: null,
    group: null,
    type: null,
    search: null
  }
}, et = ne({
  name: "myProjects",
  initialState: xa,
  reducers: {
    setUiFilter: (e, t) => {
      e.uiFilter = t.payload;
    },
    setStorageFilter: (e, t) => {
      e.storageFilter = t.payload;
    }
  }
}), { setUiFilter: Ba, setStorageFilter: _a } = et.actions, Bn = (e) => e.myProjects, _n = (e) => Bn(e).uiFilter, Ue = (e) => Bn(e).storageFilter, Ta = () => P(_n), Oa = () => P(Ue), Ra = {
  uiFilter: {
    brand: null,
    group: null,
    type: null,
    search: null
  },
  storageFilter: {
    brand: null,
    group: null,
    type: null,
    search: null
  }
}, tt = ne({
  name: "publicProjectBriefs",
  initialState: Ra,
  reducers: {
    setUiFilter: (e, t) => {
      e.uiFilter = t.payload;
    },
    setStorageFilter: (e, t) => {
      e.storageFilter = t.payload;
    }
  }
}), { setUiFilter: Fa, setStorageFilter: Ha } = tt.actions, Tn = (e) => e.publicProjectBriefs, On = (e) => Tn(e).uiFilter, Ka = (e) => Tn(e).storageFilter, za = () => P(On), Qa = () => P(Ka), u = Cr({
  reducer: {
    [Je.name]: Je.reducer,
    [Ge.name]: Ge.reducer,
    [tt.name]: tt.reducer,
    [et.name]: et.reducer,
    [Ye.name]: Ye.reducer,
    [Ze.name]: Ze.reducer
  }
}), j = Sr;
var Ga = "grhr5q0";
const Va = () => {
  const e = Xt(), t = ja(), r = j();
  return e === null ? null : Ce(
    /* @__PURE__ */ n("ul", { className: Ga, children: t.map(({ createdAt: o, message: a }, s) => /* @__PURE__ */ l("li", { children: [
      /* @__PURE__ */ n(Jr, {}),
      a,
      /* @__PURE__ */ n(f, { compact: !0, onClick: () => r(Xa(s)), children: /* @__PURE__ */ n(ln, {}) })
    ] }, `error-${o}-${a}`)) }),
    e
  );
}, qa = (e) => {
  switch (e) {
    case "get-electra-info":
      return "Getting controller info";
    case "get-electra-config":
      return "Getting controller settings";
    case "set-electra-config":
      return "Saving controller settings";
    case "get-preset":
      return "Getting preset";
    case "send-preset":
      return "Sending preset";
    case "send-lua":
      return "Sending lua";
    case "get-preset-list":
      return "Getting preset list";
    case "switch-to-slot":
      return "Switching to slot";
    case "clear-slot":
      return "Clearing slot";
    case "execute-lua":
      return "Executing LUA";
    case "set-log-level":
      return "Setting log level";
  }
  return "MIDI communication";
}, Ya = (e) => {
  if (e === void 0)
    return "MIDI communication timed out";
  switch (e.type) {
    case "open-input-port":
    case "close-input-port":
    case "open-output-port":
    case "close-output-port": {
      const t = e.type.startsWith("open") ? "Opening" : "Clossing", r = e.type === "close-input-port" || e.type === "open-input-port" ? un(u.getState()) : hn(u.getState()), o = e.portId, a = r.find(({ id: s }) => s === o);
      return a !== void 0 ? `${t} port ${a.name} failed because it took too long` : `${t} an unknown port failed because it took too long`;
    }
    case "get-electra-info":
    case "get-electra-config":
    case "set-electra-config":
    case "get-preset":
    case "send-preset":
    case "send-lua":
    case "get-preset-list":
    case "switch-to-slot":
    case "clear-slot":
    case "execute-lua":
    case "set-log-level": {
      const t = qa(e.type), { inputId: r, outputId: o } = e, s = Me(u.getState()).find(
        ({ "1": i, "2": c, ctrl: h }) => [i.input, c.input, h.input].includes(r) && [i.output, c.output, h.output].includes(o)
      );
      return s !== void 0 ? `${t} for ${s.serial} failed because it took too long` : `${t} for an unknown failed because it took too long`;
    }
  }
}, { pushError: Ja, clearOldErrors: Wa, removeErrorAtIndex: Xa } = Ze.actions, Se = () => {
  const e = it();
  return Ae(
    (t, r = "POST") => {
      e(t, { method: r, encType: "application/json" });
    },
    [e]
  );
}, $e = async (e, t) => {
  try {
    return await e();
  } catch (r) {
    if (r instanceof Gr) {
      const o = Ya(r.actionHint);
      return console.error(o), u.dispatch(Ja(o)), window.setTimeout(
        () => u.dispatch(Wa()),
        xn + 1e3
      ), t !== void 0 ? await t() : null;
    }
    throw r;
  }
}, Za = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536
}, Dt = (e) => typeof window < "u" ? window.matchMedia(e).matches : !1, Rn = (e, t) => {
  const r = `(${t === "up" ? "min" : "max"}-width: ${Za[e]}px)`, [o, a] = S(Dt(r)), s = Ae(() => {
    a(Dt(r));
  }, [r]);
  return F(() => {
    const i = window.matchMedia(r);
    return s(), i.addEventListener("change", s), () => {
      i.removeEventListener("change", s);
    };
  }, [s, r]), o;
}, es = "md", ts = "up", Q = () => Rn(
  es,
  ts
), Fn = (e) => {
  const [t, r] = S();
  return Ir(() => {
    if (e.current !== null) {
      const o = e.current.getBoundingClientRect();
      r(o);
    }
  }, [e]), co(e, (o) => r(o.contentRect)), t;
}, Ie = me(null);
Ie.displayName = "ActionsContext";
const Hn = () => ge(Ie);
var ns = "lbxbx90", rs = "lbxbx91 h0eyxr1";
const os = ({
  className: e,
  user: t,
  size: r = 4,
  onClick: o
}) => {
  const [a, { isLoading: s }] = je(t);
  return /* @__PURE__ */ n(
    Zt,
    {
      className: e,
      src: s ? !1 : a,
      size: r,
      onClick: o
    }
  );
};
let nt;
const E = () => {
  if (nt === void 0)
    throw new Error("Storage not initialized, call initializeStorage");
  return nt;
}, as = (e) => nt = e, ss = "project-biref", is = "project-preview-url", ls = "user-avatar", xt = (e) => [
  ss,
  e
], cs = (e, t) => [
  is,
  e,
  t
], ds = (e) => [
  ls,
  e
], Kn = (e, t) => {
  const r = E(), o = Jt({
    queryKey: cs(e, t),
    queryFn: () => r.getProjectPagePreviewUrl(e, t),
    staleTime: 1 / 0
  });
  return [o.data ?? null, o];
}, je = (e) => {
  const t = E(), r = Jt({
    queryKey: ds(e),
    queryFn: () => t.getUserAvatarUrl(e),
    staleTime: 1 / 0
  });
  return [r.data ?? null, r];
};
var us = "k15p1y0", hs = "k15p1y1", ps = "k15p1y2", ms = "k15p1y3", gs = "k15p1y4", vs = "k15p1y5";
const fs = ({ item: e, onClick: t }) => {
  const [r, o] = S(!1), a = ve(null), [s, { isLoading: i }] = je(
    e.user
  ), [c, { isLoading: h }] = Kn(
    e.id,
    1
  ), p = Hn();
  return F(() => {
    const d = a.current;
    if (d === null)
      return;
    const m = () => t == null ? void 0 : t(), b = (g) => {
      g.target !== null && !(g.target instanceof window.HTMLButtonElement) && (g.preventDefault(), o(!0));
    }, v = (g) => {
      g.target !== null && g.target instanceof window.Element && !d.contains(g.target) && o(!1);
    };
    return d.addEventListener("click", m), d.addEventListener("touchend", b), document.addEventListener("click", v), document.addEventListener("touchend", v), () => {
      d.removeEventListener("touchend", b), d.removeEventListener("click", m), document.removeEventListener("touchend", v), document.removeEventListener("click", v);
    };
  }, [t]), /* @__PURE__ */ l("div", { ref: a, className: us, children: [
    /* @__PURE__ */ n(
      ct,
      {
        className: ms,
        imgClassName: gs,
        src: h ? !1 : c,
        placeholder: !1
      }
    ),
    /* @__PURE__ */ n("header", { className: hs, children: e.name }),
    /* @__PURE__ */ l("span", { className: ps, children: [
      /* @__PURE__ */ n(Zt, { src: i ? !1 : s, size: 4 }),
      "by ",
      e.user.name ?? e.user.email
    ] }),
    /* @__PURE__ */ n(
      "div",
      {
        style: { visibility: r ? "visible" : void 0 },
        className: vs,
        onClick: (d) => d.stopPropagation(),
        children: p !== null && /* @__PURE__ */ n(p, { touch: r })
      }
    )
  ] });
};
var ys = "_1s3tj790";
const ue = me(null);
ue.displayName = "ItemContext";
const zn = () => {
  const e = ge(ue);
  if (e === null)
    throw new Error(`${ue.displayName} is null`);
  return e;
}, Ss = ({ items: e, first: t, last: r, columnCount: o, onClick: a }) => /* @__PURE__ */ n(
  "ul",
  {
    className: ys,
    style: {
      gridTemplateColumns: `repeat(${o}, minmax(300px, 1fr))`,
      paddingTop: t ? 0 : void 0,
      paddingBottom: r ? 0 : void 0
    },
    children: e.map((s) => /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(ue.Provider, { value: s, children: /* @__PURE__ */ n(fs, { item: s, onClick: () => a == null ? void 0 : a(s.id) }) }) }, `grid-cell-${s.id}`))
  }
), ke = me(null);
ke.displayName = "ProjectBriefCollectionContext";
const De = () => {
  const e = ge(ke);
  if (e === null)
    throw new Error(`${ke.displayName} is null`);
  return e;
}, Qn = () => {
  const { data: e } = De();
  if (e === void 0)
    throw new Error("project brief data is undefined");
  return e;
}, Gn = () => {
  const { loadMore: e, isLoadingMore: t, hasMore: r } = De();
  return { loadMore: e, isLoadingMore: t, hasMore: r };
}, Ps = ({ onItemClick: e }) => {
  const [t, r] = S(-1), o = ve(null), a = Fn(o);
  F(() => {
    a !== void 0 && (a.width < 640 ? r(1) : a.width < 970 ? r(2) : r(3));
  }, [a]);
  const s = Qn(), { isLoadingMore: i, hasMore: c, loadMore: h } = Gn(), p = T(() => {
    if (t < 1)
      return [];
    const m = Array.from(uo(s, t));
    return m.map((b, v) => /* @__PURE__ */ n(
      Ss,
      {
        items: b,
        first: v === 0,
        last: v === m.length - 1,
        columnCount: t,
        onClick: e
      },
      `grid-view-row-${b.reduce((g, w) => g + w.id, "")}`
    ));
  }, [s, t, e]), d = Math.floor(s.length / t);
  return /* @__PURE__ */ n("div", { ref: o, children: /* @__PURE__ */ n(
    dn,
    {
      overscan: 30,
      onRangeChange: (m, b) => {
        !c || i || b >= d - 30 && (console.log("load"), h());
      },
      children: p
    }
  ) });
}, bs = ({ onItemClick: e }) => {
  const { data: t } = De();
  return t === void 0 ? /* @__PURE__ */ n(Vn, {}) : /* @__PURE__ */ n(Ps, { onItemClick: e });
}, Vn = () => {
  const [e, t] = S(-1), r = ve(null), o = Fn(r);
  return F(() => {
    o !== void 0 && (o.width < 640 ? t(1) : o.width < 970 ? t(2) : t(3));
  }, [o]), /* @__PURE__ */ n(
    "div",
    {
      ref: r,
      className: ns,
      style: {
        gridTemplateColumns: `repeat(${e}, minmax(300px, 1fr))`
      },
      children: B(99, (a) => /* @__PURE__ */ n(
        "div",
        {
          className: rs
        },
        `grid-view-skeleton-item-${a}`
      ))
    }
  );
};
var Cs = "_1hiuy110", ws = "_1hiuy111";
const Is = ({
  onClick: e
}) => {
  const t = zn(), [r, { isLoading: o }] = Kn(
    t.id,
    1
  ), [a, { isLoading: s }] = je(
    t.user
  ), i = Hn();
  return /* @__PURE__ */ n(
    _r,
    {
      id: t.id,
      name: t.name,
      description: t.description,
      previewUrl: o ? !1 : r,
      author: t.user.name ?? "",
      avatarUrl: s ? !1 : a,
      onPreviewClick: e,
      children: i !== null && /* @__PURE__ */ n(i, {})
    }
  );
}, ks = ({ data: e, last: t, onClick: r }) => /* @__PURE__ */ n("div", { className: L([Cs, t && ws]), children: /* @__PURE__ */ n(ue.Provider, { value: e, children: /* @__PURE__ */ n(Is, { onClick: r }) }) });
var Ns = "qb9hle0";
const As = ({ onItemClick: e }) => {
  const t = Qn(), { isLoadingMore: r, hasMore: o, loadMore: a } = Gn(), s = T(
    () => t.map((i, c) => /* @__PURE__ */ n(
      ks,
      {
        data: i,
        last: c === t.length - 1,
        onClick: () => e == null ? void 0 : e(i.id)
      },
      `project-list-item-${i.id}`
    )),
    [t, e]
  );
  return /* @__PURE__ */ n(
    dn,
    {
      overscan: 30,
      onRangeChange: (i, c) => {
        !o || r || c >= t.length - 30 && a();
      },
      children: s
    }
  );
}, Es = ({
  onItemClick: e
}) => {
  const { data: t } = De();
  return t === void 0 ? /* @__PURE__ */ n(qn, {}) : /* @__PURE__ */ n(As, { onItemClick: e });
}, qn = () => /* @__PURE__ */ n("div", { className: Ns, children: B(24, (e) => /* @__PURE__ */ n(Tr, {}, `project-brief-placeholder-${e}`)) });
var Yn = "_1p2plln0";
const Ms = [
  { id: "ableton", name: "Ableton" },
  { id: "access", name: "Access" },
  { id: "air music", name: "Air Music" },
  { id: "akai", name: "Akai" },
  { id: "alesis", name: "Alesis" },
  { id: "ample sound", name: "Ample Sound" },
  { id: "anyma phi", name: "Anyma Phi" },
  { id: "applied acoustics", name: "Applied Acoustics" },
  { id: "arturia", name: "Arturia" },
  { id: "asm", name: "Asm" },
  { id: "audio thing", name: "Audio Thing" },
  { id: "audiokit", name: "Audiokit" },
  { id: "audiority", name: "Audiority" },
  { id: "audiothingies", name: "Audiothingies" },
  { id: "black corporation", name: "Black Corporation" },
  { id: "behringer", name: "Behringer" },
  { id: "bitwig", name: "Bitwig" },
  { id: "boss", name: "Boss" },
  { id: "casio", name: "Casio" },
  { id: "chase bliss audio", name: "Chase Bliss Audio" },
  { id: "cheetah", name: "Cheetah" },
  { id: "cherry audio", name: "Cherry Audio" },
  { id: "clavia", name: "Clavia" },
  { id: "conductive labs", name: "Conductive Labs" },
  { id: "cradle", name: "Cradle" },
  { id: "crumar", name: "Crumar" },
  { id: "cubase", name: "Cubase" },
  { id: "d16 group", name: "D16 Group" },
  { id: "dave smith instruments", name: "Dave Smith Instruments" },
  { id: "disco-dsp", name: "Disco-dsp" },
  { id: "dreadbox", name: "Dreadbox" },
  { id: "ds audio", name: "Ds Audio" },
  { id: "dsi", name: "DSI" },
  { id: "electra one", name: "Electra One" },
  { id: "elektron", name: "Elektron" },
  { id: "e-mu", name: "E-mu" },
  { id: "ensoniq", name: "Ensoniq" },
  { id: "eventide", name: "Eventide" },
  { id: "expert sleepers", name: "Expert Sleepers" },
  { id: "expressive e", name: "Expressive E" },
  { id: "focusrite", name: "Focusrite" },
  { id: "full bucket music", name: "Full Bucket Music" },
  { id: "gamechangeraudio", name: "Game Changer Audio" },
  { id: "gem", name: "Gem" },
  { id: "generic", name: "Generic" },
  { id: "gfi system", name: "Gfi System" },
  { id: "gotharman", name: "Gotharman" },
  { id: "gsi", name: "Gsi" },
  { id: "haken", name: "Haken" },
  { id: "hawk", name: "Hawk" },
  { id: "hypersynth", name: "Hypersynth" },
  { id: "ik multimedia", name: "IK Multimedia" },
  { id: "izotope", name: "Izotope" },
  { id: "jomox", name: "Jomox" },
  { id: "kawai", name: "Kawai" },
  { id: "kiwi", name: "Kiwi" },
  { id: "knif audio", name: "Knif Audio" },
  { id: "korg", name: "Korg" },
  { id: "kurzweil", name: "Kurzweil" },
  { id: "kv331 audio", name: "Kv331 Audio" },
  { id: "lexicon", name: "Lexicon" },
  { id: "linn electronics", name: "Linn Electronics" },
  { id: "logic", name: "Logic" },
  { id: "madrona labs", name: "Madrona Labs" },
  { id: "martin luders", name: "Martin Luders" },
  { id: "memorymoon", name: "Memorymoon" },
  { id: "mfb", name: "MFB" },
  { id: "midibox", name: "Midibox" },
  { id: "modal electronics", name: "Modal Electronics" },
  { id: "modor", name: "Modor" },
  { id: "moog", name: "Moog" },
  { id: "mutable instruments", name: "Mutable Instruments" },
  { id: "native instruments", name: "Native Instruments" },
  { id: "novation", name: "Novation" },
  { id: "oberheim", name: "Oberheim" },
  { id: "oto machines", name: "Oto Machines" },
  { id: "pioneer", name: "Pioneer" },
  { id: "plinky", name: "Plinky" },
  { id: "polyend", name: "Polyend" },
  { id: "positive grid", name: "Positive grid" },
  { id: "ppg", name: "Ppg" },
  { id: "propellerhead", name: "Propellerhead" },
  { id: "protools", name: "Protools" },
  { id: "quantiloop", name: "Quantiloop" },
  { id: "quasimidi", name: "Quasimidi" },
  { id: "reaper", name: "Reaper" },
  { id: "red sound systems", name: "Red Sound Systems" },
  { id: "reveal sound", name: "Reveal Sound" },
  { id: "rhodes", name: "Rhodes" },
  { id: "roland", name: "Roland" },
  { id: "roli", name: "Roli" },
  { id: "sequential", name: "Sequential" },
  { id: "sherman", name: "Sherman" },
  { id: "siel", name: "Siel" },
  { id: "softube", name: "Softube" },
  { id: "sonic potions", name: "Sonic Potions" },
  { id: "sonicprojects", name: "Sonicprojects" },
  { id: "sonicware", name: "Sonicware" },
  { id: "soundtoys", name: "Soundtoys" },
  { id: "spektro audio", name: "Spektro Audio" },
  { id: "spitfire audio", name: "Spitfire Audio" },
  { id: "strymon", name: "Strymon" },
  { id: "studio electronics", name: "Studio Electronics" },
  { id: "surreal machines", name: "Surreal Machines" },
  { id: "synapse audio", name: "Synapse Audio" },
  { id: "synthstrom", name: "Synthstrom" },
  { id: "syntorial", name: "Syntorial" },
  { id: "tal", name: "Tal" },
  { id: "tauntek", name: "Tauntek" },
  { id: "tc electronic", name: "TC Electronic" },
  { id: "technics", name: "Technics" },
  { id: "teisco", name: "Teisco" },
  { id: "tunefish", name: "Tunefish" },
  { id: "twisted electrons", name: "Twisted Electrons" },
  { id: "uad audio", name: "UAD Audio" },
  { id: "udo audio", name: "Udo Audio" },
  { id: "u-he", name: "U-he" },
  { id: "uvi", name: "Uvi" },
  { id: "vector", name: "Vector" },
  { id: "wa production", name: "Wa production" },
  { id: "waldorf", name: "Waldorf" },
  { id: "waves", name: "Waves" },
  { id: "xfer records", name: "Xfer Records" },
  { id: "xln addictive keys", name: "Xln Addictive keys" },
  { id: "yamaha", name: "Yamaha" }
], Ls = [
  {
    id: "hardware",
    name: "Hardware"
  },
  {
    id: "software",
    name: "Software"
  },
  {
    id: "midi processing",
    name: "MIDI processing"
  },
  {
    id: "tutorial",
    name: "Tutorial"
  }
], Us = [
  {
    id: "synthesizer",
    name: "Synthesizer"
  },
  {
    id: "drum machine",
    name: "Drum machine"
  },
  {
    id: "fx",
    name: "FX"
  },
  {
    id: "sequencer",
    name: "Sequencer"
  },
  {
    id: "controller",
    name: "Controller"
  }
];
var rt = "n56e5s0", Jn = "n56e5s1", ot = "n56e5s2", $s = "n56e5s3";
const js = ({
  filter: e,
  viewMode: t,
  onFilterChange: r,
  onViewModeChange: o
}) => {
  const [a, s] = S(e.search ?? ""), i = ho(r, 1e3), [c, h] = S(!1), p = Q(), d = Ae(
    (v) => {
      const g = v.target.value.substring(0, 20);
      s(g), i({
        ...e,
        search: g.length > 0 ? g : null
      });
    },
    [i, e]
  ), m = /* @__PURE__ */ l(_, { children: [
    /* @__PURE__ */ l(
      R,
      {
        value: e.brand ?? "all",
        onChange: (v) => r({
          ...e,
          brand: v.target.value === "all" ? null : v.target.value
        }),
        children: [
          /* @__PURE__ */ n("option", { value: "all", children: "All brands" }),
          Ms.map((v) => /* @__PURE__ */ n("option", { value: v.id, children: v.name }, `brand-selector-brand-${v.id}`))
        ]
      }
    ),
    /* @__PURE__ */ l(
      R,
      {
        value: e.type ?? "all",
        onChange: (v) => r({
          ...e,
          type: v.target.value === "all" ? null : v.target.value
        }),
        children: [
          /* @__PURE__ */ n("option", { value: "all", children: "All types" }),
          Us.map((v) => /* @__PURE__ */ n("option", { value: v.id, children: v.name }, `type-selector-type-${v.id}`))
        ]
      }
    ),
    /* @__PURE__ */ l(
      R,
      {
        value: e.group ?? "all",
        onChange: (v) => r({
          ...e,
          group: v.target.value === "all" ? null : v.target.value
        }),
        children: [
          /* @__PURE__ */ n("option", { value: "all", children: "All groups" }),
          Ls.map((v) => /* @__PURE__ */ n("option", { value: v.id, children: v.name }, `group-selector-group-${v.id}`))
        ]
      }
    ),
    /* @__PURE__ */ n(
      ce,
      {
        value: a,
        maxLength: 20,
        placeholder: "Search",
        onChange: d
      }
    )
  ] }), b = /* @__PURE__ */ n(
    dt,
    {
      onClick: () => o(t === "grid" ? "list" : "grid"),
      children: t === "grid" ? /* @__PURE__ */ n(Zr, {}) : /* @__PURE__ */ n(eo, {})
    }
  );
  return p ? /* @__PURE__ */ l("div", { className: rt, children: [
    /* @__PURE__ */ n("div", { className: ot, children: m }),
    b
  ] }) : /* @__PURE__ */ l("div", { className: rt, children: [
    /* @__PURE__ */ l("div", { className: Jn, children: [
      /* @__PURE__ */ l(
        f,
        {
          compact: !0,
          className: $s,
          onClick: () => h(!c),
          children: [
            c ? /* @__PURE__ */ n(Wr, {}) : /* @__PURE__ */ n(Xr, {}),
            c ? "Hide" : "Show",
            " filter"
          ]
        }
      ),
      b
    ] }),
    c && /* @__PURE__ */ n("div", { className: ot, children: m })
  ] });
}, Ds = () => Q() ? /* @__PURE__ */ n("div", { className: rt, children: /* @__PURE__ */ l("div", { className: ot, children: [
  /* @__PURE__ */ n(Te, {}),
  /* @__PURE__ */ n(Te, {}),
  /* @__PURE__ */ n(Te, {})
] }) }) : /* @__PURE__ */ l("div", { className: Jn, children: [
  /* @__PURE__ */ n(Or, { compact: !0 }),
  /* @__PURE__ */ n(Rr, {})
] }), xs = (e) => e === "list" || e === "grid", Wn = "viewMode", Bs = (e) => localStorage.setItem(Wn, e), Xn = () => {
  const e = localStorage.getItem(Wn);
  return e === null || !xs(e) ? "grid" : e;
}, Zn = ({
  data: e,
  isLoadingMore: t,
  hasMore: r,
  filter: o,
  gridActions: a,
  listActions: s,
  onLoadMore: i,
  onFilterChange: c,
  onItemClick: h
}) => {
  const p = T(
    () => ({
      data: e,
      isLoadingMore: t,
      hasMore: r,
      loadMore: i
    }),
    [e, t, r, i]
  ), [d, m] = S(Xn());
  return /* @__PURE__ */ n(ke.Provider, { value: p, children: /* @__PURE__ */ l("div", { className: Yn, children: [
    /* @__PURE__ */ n(
      js,
      {
        filter: o,
        viewMode: d,
        onFilterChange: c,
        onViewModeChange: (b) => {
          Bs(b), m(b);
        }
      }
    ),
    d === "grid" && /* @__PURE__ */ n(Ie.Provider, { value: a, children: /* @__PURE__ */ n(bs, { onItemClick: h }) }),
    d === "list" && /* @__PURE__ */ n(Ie.Provider, { value: s, children: /* @__PURE__ */ n(Es, { onItemClick: h }) })
  ] }) });
}, _s = () => {
  const e = Xn();
  return /* @__PURE__ */ l("div", { className: Yn, children: [
    /* @__PURE__ */ n(Ds, {}),
    e === "grid" && /* @__PURE__ */ n(Vn, {}),
    e === "list" && /* @__PURE__ */ n(qn, {})
  ] });
};
var Ts = "_11mshio0";
const xe = ({
  always: e,
  paddingLeft: t,
  children: r
}) => {
  const o = Q();
  return !e && o ? null : /* @__PURE__ */ n(
    "header",
    {
      className: Ts,
      style: typeof t == "number" ? { paddingLeft: en(q.oneUnit, t) } : void 0,
      children: r
    }
  );
};
var Os = "_1b1p4td0";
const ft = kr(
  ({
    header: e,
    children: t,
    ...r
  }, o) => /* @__PURE__ */ l(
    "div",
    {
      ...r,
      className: L(Os, r.className),
      ref: o,
      children: [
        /* @__PURE__ */ n(xe, { children: e }),
        t
      ]
    }
  )
), yt = me(null);
yt.displayName = "LayoutContext";
const Y = ({ children: e }) => {
  const t = ge(yt);
  return t === null || t.mainColumn === null ? null : Ce(e, t.mainColumn);
};
var Rs = "_13a1ov40", Fs = "_13a1ov41", Hs = "_13a1ov42", Ks = "_13a1ov43", zs = "_13a1ov44", Qs = "_13a1ov45", Gs = "_13a1ov46", Vs = "_13a1ov47", Bt = "_13a1ov48", _t = "_13a1ov49", qs = "ixgbx40";
const St = ({ color: e }) => /* @__PURE__ */ n(
  "div",
  {
    className: qs,
    style: { backgroundColor: q.color[e] }
  }
);
var Ys = "lajwin0", Js = "lajwin1";
const Re = ({
  active: e,
  icon: t,
  to: r,
  target: o,
  onClick: a,
  children: s
}) => /* @__PURE__ */ l(
  lt,
  {
    to: r,
    target: o,
    className: L([Ys, e && Js]),
    onClick: a,
    children: [
      t,
      s
    ]
  }
);
var Ws = "_1thsd1u0", Xs = "_1thsd1u1", Zs = "_1thsd1u2", ei = "sk0lye0", ti = "sk0lye1";
const ni = ({
  active: e,
  icon: t,
  to: r,
  target: o,
  onClick: a,
  children: s
}) => /* @__PURE__ */ l(
  lt,
  {
    to: r,
    target: o,
    className: L([ei, e && ti]),
    onClick: a,
    children: [
      t,
      s
    ]
  }
);
var ri = "_1rletut0";
const oi = ({
  color: e,
  size: t = 32
}) => /* @__PURE__ */ n(
  "div",
  {
    className: ri,
    style: { backgroundColor: q.color[e], width: t }
  }
);
var ai = "pfd1rg0", si = "pfd1rg1", ii = "pfd1rg2";
const er = ({
  variant: e = "regular",
  wrap: t = !1,
  onChange: r
}) => {
  const o = O(), a = Yo(), s = j(), i = e === "regular" ? si : ii;
  return /* @__PURE__ */ n("ul", { className: ai, style: { flexWrap: t ? "wrap" : "nowrap" }, children: a.map((c, h) => /* @__PURE__ */ n("li", { children: /* @__PURE__ */ l(
    f,
    {
      variant: e,
      className: L(
        h !== o && i
      ),
      onClick: () => {
        s(kn(h)), r == null || r();
      },
      children: [
        /* @__PURE__ */ n(oi, { color: "accent" }),
        c.serial
      ]
    }
  ) }, `electra-selector-${c.serial}`)) });
};
var li = "_1iz8civ0", ci = "_1jtswr11";
const tr = () => {
  const e = mt(), t = O();
  return e ? ["Discovering controllers...", !0] : t < 0 ? ["No controller found", !1] : [null, !1];
}, di = ({
  onSidebarClose: e
}) => {
  const [t, r] = tr();
  return r ? /* @__PURE__ */ l("strong", { className: li, children: [
    /* @__PURE__ */ n(cn, { className: ci }),
    t
  ] }) : t !== null ? /* @__PURE__ */ n("strong", { children: t }) : /* @__PURE__ */ l(_, { children: [
    /* @__PURE__ */ n("strong", { children: "Discovered Electras" }),
    /* @__PURE__ */ n(er, { wrap: !0, onChange: e })
  ] });
}, Tt = [
  {
    id: $.PrivateProjects,
    icon: /* @__PURE__ */ n(to, {}),
    to: "librarian/private-projects",
    label: "My projects"
  },
  {
    id: $.PublicProjects,
    icon: /* @__PURE__ */ n(no, {}),
    to: "librarian/public-projects",
    label: "Public projects"
  },
  {
    id: $.ControllerSettings,
    icon: /* @__PURE__ */ n(ro, {}),
    to: "controller-settings/router",
    label: "Controller settings"
  },
  {
    id: $.ControllerInfo,
    icon: /* @__PURE__ */ n(oo, {}),
    to: "controller-info",
    label: "Controller info"
  },
  {
    id: $.LuaConsole,
    icon: /* @__PURE__ */ n(ut, {}),
    to: "lua-console",
    label: "Lua console"
  }
], ui = ({
  toolbarParent: e,
  sidebarOpen: t,
  onSidebarClose: r
}) => {
  const o = La(), a = Xt();
  return Q() ? e === null ? null : Ce(
    /* @__PURE__ */ n(_, { children: Tt.map(({ id: i, icon: c, to: h, label: p }) => /* @__PURE__ */ n(
      ni,
      {
        to: h,
        icon: c,
        active: i === o,
        onClick: r,
        children: p
      },
      `nav-button-${i}`
    )) }),
    e
  ) : a === null ? null : Ce(
    /* @__PURE__ */ n(
      "div",
      {
        className: Ws,
        style: t ? {
          pointerEvents: "auto",
          backdropFilter: `blur(${en(q.oneUnit, 1)})`
        } : {
          backgroundColor: `${He(q.color.accent, 0)}`
        },
        onClick: r,
        children: /* @__PURE__ */ l(
          "div",
          {
            className: Xs,
            style: t ? { pointerEvents: "auto", transform: "translateX(0)" } : void 0,
            onClick: (i) => i.stopPropagation(),
            children: [
              /* @__PURE__ */ l("div", { className: Zs, children: [
                /* @__PURE__ */ n(St, { color: "secondary" }),
                /* @__PURE__ */ n(dt, { onClick: r, children: /* @__PURE__ */ n(ln, {}) })
              ] }),
              /* @__PURE__ */ n(di, { onSidebarClose: r }),
              /* @__PURE__ */ n(Fr, { orientation: "horizontal" }),
              Tt.map(({ id: i, icon: c, to: h, label: p }) => /* @__PURE__ */ n(
                Re,
                {
                  icon: c,
                  to: h,
                  active: i === o,
                  onClick: r,
                  children: p
                },
                `nav-button-${i}`
              )),
              /* @__PURE__ */ n(
                Re,
                {
                  active: o === $.MidiConsole,
                  icon: /* @__PURE__ */ n(ut, {}),
                  to: "midi-console",
                  onClick: r,
                  children: "MIDI console"
                }
              ),
              /* @__PURE__ */ n(
                Re,
                {
                  icon: /* @__PURE__ */ n(Ee, {}),
                  to: "https://docs.electra.one/",
                  target: "_blank",
                  onClick: r,
                  children: "Help"
                }
              )
            ]
          }
        )
      }
    ),
    a
  );
};
var Ot = "_151a4jo0", hi = "_151a4jo2 _151a4jo1", pi = "_151a4jo3 _151a4jo1", mi = "_1jtswr11";
const gi = () => {
  const [e, t] = tr();
  return Q() ? t ? /* @__PURE__ */ n("div", { className: Ot, children: /* @__PURE__ */ l("span", { className: pi, children: [
    /* @__PURE__ */ n(cn, { className: mi }),
    e
  ] }) }) : e !== null ? /* @__PURE__ */ n("div", { className: Ot, children: /* @__PURE__ */ n("span", { className: hi, children: e }) }) : /* @__PURE__ */ n(er, { variant: "inverted" }) : null;
};
var Rt = "_174qzus0", vi = "_174qzus1", fi = "_174qzus2";
const yi = () => {
  const e = Le(), t = it(), r = H(), [o, a] = S(!1), s = ve(null);
  return /* @__PURE__ */ n($n, { fallback: null, children: e === null ? /* @__PURE__ */ n("div", { className: Rt, children: /* @__PURE__ */ n(f, { variant: "inverted", onClick: () => r("login"), children: "Log in" }) }) : /* @__PURE__ */ l("div", { ref: s, className: Rt, children: [
    /* @__PURE__ */ n(
      os,
      {
        user: e,
        size: 5,
        className: vi,
        onClick: () => a(!o)
      }
    ),
    o && /* @__PURE__ */ l(
      Hr,
      {
        anchor: "right",
        rootRef: s,
        className: fi,
        onClose: () => a(!1),
        children: [
          /* @__PURE__ */ n("span", { children: e.name ?? e.email }),
          /* @__PURE__ */ n(
            f,
            {
              onClick: () => {
                a(!1), t(null, {
                  method: "post",
                  action: "/logout"
                });
              },
              children: "Log out"
            }
          )
        ]
      }
    )
  ] }) });
}, Si = ({ children: e }) => {
  const [t, r] = S(!1), o = Q(), [a, s] = S(null), [i, c] = S(null), [h, p] = S(null), [d, m] = S(null), b = T(
    () => ({
      leftColumn: i,
      mainColumn: h,
      rightColumn: d
    }),
    [i, h, d]
  ), { state: v, formData: g } = Er(), w = pr(), D = v === "loading" && g == null, k = v === "submitting", M = w > 0;
  return /* @__PURE__ */ l("div", { className: Rs, children: [
    /* @__PURE__ */ l("div", { className: Fs, children: [
      !o && /* @__PURE__ */ n(
        dt,
        {
          className: zs,
          onClick: () => r(!t),
          children: /* @__PURE__ */ n(ao, {})
        }
      ),
      /* @__PURE__ */ n(St, { color: "primary" }),
      /* @__PURE__ */ n(gi, {}),
      o && /* @__PURE__ */ l(_, { children: [
        /* @__PURE__ */ l(lt, { className: _t, to: "/midi-console", children: [
          /* @__PURE__ */ n(ut, { size: 20 }),
          "MIDI connsole"
        ] }),
        /* @__PURE__ */ l(
          "a",
          {
            className: _t,
            href: "https://docs.electra.one/",
            target: "_blank",
            children: [
              /* @__PURE__ */ n(Ee, { size: 20 }),
              "Help"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ n(yi, {})
    ] }),
    (D || M || k) && /* @__PURE__ */ n(Kr, { className: Qs }),
    /* @__PURE__ */ n("div", { className: Gs, children: /* @__PURE__ */ l(yt.Provider, { value: b, children: [
      /* @__PURE__ */ n(
        "div",
        {
          ref: (N) => c(N),
          className: Bt
        }
      ),
      /* @__PURE__ */ n("div", { ref: (N) => p(N), className: Vs, children: /* @__PURE__ */ n("div", { className: Hs, children: /* @__PURE__ */ n(
        "div",
        {
          className: Ks,
          ref: (N) => s(N)
        }
      ) }) }),
      /* @__PURE__ */ n(
        "div",
        {
          ref: (N) => m(N),
          className: Bt
        }
      ),
      /* @__PURE__ */ n("div", { style: { display: "none" }, children: e })
    ] }) }),
    /* @__PURE__ */ n(
      ui,
      {
        toolbarParent: a,
        sidebarOpen: t,
        onSidebarClose: () => r(!1)
      }
    )
  ] });
};
var Pi = "_1p7mli50", bi = "_1p7mli51", Ci = "_1p7mli52";
const wi = (e) => e >= 3 ? "mk2" : "mk1", Ii = {
  mk1: "mkI",
  mk2: "mkII"
}, ki = () => {
  const e = an(), t = qo(), r = Jo(t.ctrl.input), o = Wo(t.ctrl.output), a = wi(t.hwRevision), s = e.firmwareVersion[a], i = t.swVersion === s;
  return /* @__PURE__ */ l("div", { className: Pi, children: [
    !i && /* @__PURE__ */ l("div", { className: Ci, children: [
      "A new firmware version (",
      s,
      ") is available for your controller.",
      " ",
      /* @__PURE__ */ n("a", { href: "https://app.electra.one/electra", target: "_blank", children: "Update firmware" })
    ] }),
    /* @__PURE__ */ n("img", { src: e.electraOneProductPictureUrl }),
    /* @__PURE__ */ l("div", { className: bi, children: [
      /* @__PURE__ */ l("header", { children: [
        "Electra One Controller ",
        Ii[a]
      ] }),
      /* @__PURE__ */ l("ul", { children: [
        /* @__PURE__ */ l("li", { children: [
          /* @__PURE__ */ n("span", { children: "Hardware revision" }),
          t.hwRevision.toFixed(1)
        ] }),
        /* @__PURE__ */ l("li", { children: [
          /* @__PURE__ */ n("span", { children: "Firmware revision" }),
          t.swVersion
        ] }),
        /* @__PURE__ */ l("li", { children: [
          /* @__PURE__ */ n("span", { children: "Serial number" }),
          t.serial
        ] })
      ] }),
      /* @__PURE__ */ n("strong", { children: "MIDI port configuration" }),
      "Below are the ports detected for this Electra One:",
      /* @__PURE__ */ l("ul", { children: [
        /* @__PURE__ */ l("li", { children: [
          /* @__PURE__ */ n("span", { children: "Input" }),
          (r == null ? void 0 : r.name) ?? "Unknown"
        ] }),
        /* @__PURE__ */ l("li", { children: [
          /* @__PURE__ */ n("span", { children: "Output" }),
          (o == null ? void 0 : o.name) ?? "Unknown"
        ] })
      ] })
    ] })
  ] });
}, Ni = () => {
  const e = oe();
  return W("Controller info"), /* @__PURE__ */ l(Y, { children: [
    /* @__PURE__ */ n(xe, { children: "Controller settings" }),
    e ? /* @__PURE__ */ n(ki, {}) : /* @__PURE__ */ n("span", { children: "Electra One not connected" })
  ] });
}, Ai = ({
  onYes: e,
  onNo: t,
  onCancel: r
}) => /* @__PURE__ */ n(tn, { onClick: r, children: /* @__PURE__ */ l(nn, { children: [
  /* @__PURE__ */ n(rn, { children: "Unsaved changes" }),
  /* @__PURE__ */ n("span", { children: "There are unsaved changes. Do you want to save them?" }),
  /* @__PURE__ */ l(on, { children: [
    /* @__PURE__ */ n(f, { onClick: e, children: "Yes" }),
    /* @__PURE__ */ n(f, { onClick: t, children: "No" }),
    /* @__PURE__ */ n(f, { onClick: r, children: "Cancel" })
  ] })
] }) });
var Ei = "_1hy1hb90", Mi = "pplzaf0", y = /* @__PURE__ */ ((e) => (e.Router = "settings-router", e.MidiControl = "settings-midi", e.UsbHost = "settings-usb-host", e.UserInterface = "settings-ui", e.PresetBanks = "settings-preset-banks", e))(y || {});
const Li = ({
  activePage: e,
  onChange: t,
  onSave: r
}) => /* @__PURE__ */ l("div", { className: Mi, children: [
  /* @__PURE__ */ l(
    be,
    {
      id: "settings-small-screen-navigation",
      label: "Navigation",
      value: e ?? "",
      onChange: (o) => t(o.target.value),
      children: [
        /* @__PURE__ */ n("option", { value: y.Router, children: "Router" }),
        /* @__PURE__ */ n("option", { value: y.MidiControl, children: "MIDI Control" }),
        /* @__PURE__ */ n("option", { value: y.UsbHost, children: "USB Host" }),
        /* @__PURE__ */ n("option", { value: y.UserInterface, children: "User Interface" }),
        /* @__PURE__ */ n("option", { value: y.PresetBanks, children: "Preset Banks" })
      ]
    }
  ),
  /* @__PURE__ */ n(f, { onClick: r, children: "Save" })
] }), Ui = () => {
  const e = st();
  return T(
    () => [
      y.Router,
      y.MidiControl,
      y.UsbHost,
      y.UserInterface,
      y.PresetBanks
    ].find((t) => e.some((r) => r.id === t)) ?? null,
    [e]
  );
}, Ft = {
  [y.Router]: "router",
  [y.MidiControl]: "midi-control",
  [y.UsbHost]: "usb-host",
  [y.UserInterface]: "ui",
  [y.PresetBanks]: "preset-banks"
}, $i = () => {
  const e = Ui(), t = Rn("sm", "down"), r = H(), o = it(), a = (h) => {
    r(Ft[h]);
  }, s = (h) => {
    o(
      h ?? (e !== null ? Ft[e] : "router"),
      {
        method: "POST",
        encType: "text/plain"
      }
    );
  }, i = zo(), c = Mr(
    ({ nextLocation: h }) => !i && !h.pathname.startsWith("/controller-settings")
  );
  return t ? /* @__PURE__ */ n(
    Li,
    {
      activePage: e,
      onChange: a,
      onSave: s
    }
  ) : /* @__PURE__ */ l("div", { className: Ei, children: [
    /* @__PURE__ */ n(
      f,
      {
        variant: e === y.Router ? "regular" : "inverted",
        onClick: () => a(y.Router),
        children: "Router"
      }
    ),
    /* @__PURE__ */ n(
      f,
      {
        variant: e === y.MidiControl ? "regular" : "inverted",
        onClick: () => a(y.MidiControl),
        children: "MIDI Control"
      }
    ),
    /* @__PURE__ */ n(
      f,
      {
        variant: e === y.UsbHost ? "regular" : "inverted",
        onClick: () => a(y.UsbHost),
        children: "USB Host"
      }
    ),
    /* @__PURE__ */ n(
      f,
      {
        variant: e === y.UserInterface ? "regular" : "inverted",
        onClick: () => a(y.UserInterface),
        children: "User Interface"
      }
    ),
    /* @__PURE__ */ n(
      f,
      {
        variant: e === y.PresetBanks ? "regular" : "inverted",
        onClick: () => a(y.PresetBanks),
        children: "Preset banks"
      }
    ),
    /* @__PURE__ */ n(f, { disabled: i, onClick: () => s(), children: "Save" }),
    c.state === "blocked" && /* @__PURE__ */ n(
      Ai,
      {
        onYes: () => {
          s(c.location.pathname);
        },
        onNo: () => c.proceed(),
        onCancel: () => c.reset()
      }
    )
  ] });
}, ji = () => {
  const e = oe();
  return W("Controller settings"), /* @__PURE__ */ l(Y, { children: [
    /* @__PURE__ */ n(xe, { children: "Controller settings" }),
    e ? /* @__PURE__ */ l(_, { children: [
      /* @__PURE__ */ n($i, {}),
      /* @__PURE__ */ n(le, {})
    ] }) : /* @__PURE__ */ n("span", { children: "Electra One not connected" })
  ] });
}, Di = (e) => async ({ request: t }) => {
  const r = await t.text();
  return await $e(
    async () => {
      const o = J(u.getState()), a = z(u.getState());
      if (o === null || o.ctrl.input === null || o.ctrl.output === null)
        return U(r);
      const s = pn(u.getState()), i = gn(
        u.getState()
      ), c = mn(u.getState()), h = vn(u.getState()), p = fn(u.getState());
      return await e.setElectraConfiguration(
        o.ctrl.input,
        o.ctrl.output,
        {
          router: s,
          usbHostAssigments: i,
          midiControl: c,
          uiFeatures: h,
          presetBanks: p
        },
        1e4
      ), u.dispatch(ta([a, !0])), U(r);
    },
    () => U(r)
  );
}, xi = (e) => async () => {
  const t = J(u.getState()), r = z(u.getState());
  if (t === null || t.ctrl.input === null || t.ctrl.output === null)
    return null;
  try {
    return await u.dispatch(
      ht({
        communication: e,
        index: r,
        input: t.ctrl.input,
        output: t.ctrl.output
      })
    );
  } catch (o) {
    return console.error(o), null;
  }
};
var Bi = "poy9pc0", _i = "poy9pc1", Ti = "poy9pc2";
const nr = ({
  className: e,
  children: t,
  childrenClassName: r,
  actions: o
}) => /* @__PURE__ */ l("div", { className: L([Bi, e]), children: [
  /* @__PURE__ */ n("div", { className: L([_i, r]), children: t }),
  /* @__PURE__ */ n("div", { className: Ti, children: o })
] });
var Oi = "wl64970", Ri = "wl64971", Fi = "wl64972";
const Hi = ({ value: e, onChange: t }) => /* @__PURE__ */ n("ul", { className: Oi, children: G.map((r) => /* @__PURE__ */ n(
  "li",
  {
    className: L([
      Ri,
      e === r && Fi
    ]),
    style: {
      backgroundColor: `#${r}`
    },
    onClick: () => t(r)
  },
  `bank-color-${r}`
)) }), rr = ({
  className: e,
  value: t,
  onChange: r
}) => /* @__PURE__ */ l(
  R,
  {
    className: e,
    value: t,
    onChange: (o) => r(Number.parseInt(o.target.value)),
    children: [
      /* @__PURE__ */ n("option", { value: "1", children: "Port 1" }),
      /* @__PURE__ */ n("option", { value: "2", children: "Port 2" }),
      /* @__PURE__ */ n("option", { value: "3", children: "CTRL" })
    ]
  }
);
var Ki = "_154byl40";
const zi = {
  yellow: "#f9ecca",
  green: He(q.color.success, 0.3),
  shady: He(q.color.accent, 0.1)
}, I = ({
  color: e,
  placeCenter: t,
  children: r
}) => /* @__PURE__ */ n(
  "div",
  {
    className: Ki,
    style: {
      backgroundColor: e !== void 0 ? zi[e] : void 0,
      placeItems: t ? "center" : void 0
    },
    children: r
  }
), Qi = ({
  port: e,
  channel: t,
  enabled: r,
  drop: o,
  onPortChange: a,
  onChannelChange: s,
  onEnabledChange: i,
  onDropChange: c
}) => /* @__PURE__ */ l(_, { children: [
  /* @__PURE__ */ n(I, { color: "yellow", children: "All" }),
  /* @__PURE__ */ n(rr, { value: e, onChange: a }),
  /* @__PURE__ */ l(
    R,
    {
      value: t,
      onChange: (h) => s(Number.parseInt(h.target.value)),
      children: [
        /* @__PURE__ */ n("option", { value: "0", children: "Omni" }),
        /* @__PURE__ */ n("option", { value: "1", children: "1" }),
        /* @__PURE__ */ n("option", { value: "2", children: "2" }),
        /* @__PURE__ */ n("option", { value: "3", children: "3" }),
        /* @__PURE__ */ n("option", { value: "4", children: "4" }),
        /* @__PURE__ */ n("option", { value: "5", children: "5" }),
        /* @__PURE__ */ n("option", { value: "6", children: "6" }),
        /* @__PURE__ */ n("option", { value: "7", children: "7" }),
        /* @__PURE__ */ n("option", { value: "8", children: "8" }),
        /* @__PURE__ */ n("option", { value: "9", children: "9" }),
        /* @__PURE__ */ n("option", { value: "10", children: "10" }),
        /* @__PURE__ */ n("option", { value: "11", children: "11" }),
        /* @__PURE__ */ n("option", { value: "12", children: "12" }),
        /* @__PURE__ */ n("option", { value: "13", children: "13" }),
        /* @__PURE__ */ n("option", { value: "14", children: "14" }),
        /* @__PURE__ */ n("option", { value: "15", children: "15" }),
        /* @__PURE__ */ n("option", { value: "16", children: "16" })
      ]
    }
  ),
  /* @__PURE__ */ n(I, { placeCenter: !0, children: /* @__PURE__ */ n(
    Z,
    {
      checked: r,
      onChange: (h) => i(h.target.checked)
    }
  ) }),
  /* @__PURE__ */ n(I, { color: "yellow", children: "MIDI control" }),
  /* @__PURE__ */ l(
    R,
    {
      value: o ? "drop" : "pass",
      onChange: (h) => c(h.target.value === "drop"),
      children: [
        /* @__PURE__ */ n("option", { value: "drop", children: "Drop" }),
        /* @__PURE__ */ n("option", { value: "pass", children: "Pass" })
      ]
    }
  )
] }), K = ({
  source: e,
  destination: t,
  enabled: r,
  port: o = "All",
  onEnabledChange: a
}) => /* @__PURE__ */ l(_, { children: [
  /* @__PURE__ */ n(I, { color: "yellow", children: e }),
  /* @__PURE__ */ n(I, { color: "yellow", children: o }),
  /* @__PURE__ */ n(I, { color: "yellow", children: "Omni" }),
  /* @__PURE__ */ n(I, { placeCenter: !0, children: /* @__PURE__ */ n(
    Z,
    {
      checked: r,
      onChange: (s) => a(s.target.checked)
    }
  ) }),
  /* @__PURE__ */ n(I, { color: "yellow", children: t }),
  /* @__PURE__ */ n("span", {})
] });
var Gi = "_10wvv9n0", Vi = "_10wvv9n1", Ht = "_10wvv9n2", qi = "_10wvv9n3", Kt = "_10wvv9n4";
const or = ({
  inputMessage: e,
  inputParameter: t,
  outputAction: r,
  outputParameter: o,
  submitLabel: a,
  canSubmit: s,
  onInputMessageChange: i,
  onInputParameterChange: c,
  onOutputActionChange: h,
  onOutputParameterChange: p,
  onSubmit: d
}) => {
  console.log(e, t, r, o);
  const [m, b] = S(
    typeof t == "number" ? t.toString() : ""
  ), [v, g] = S(
    typeof o == "number" ? o.toString() : ""
  );
  return F(() => {
    b(
      typeof t == "number" ? t.toString() : ""
    ), g(
      typeof o == "number" ? o.toString() : ""
    );
  }, [t, o]), /* @__PURE__ */ l(
    nr,
    {
      className: Gi,
      childrenClassName: Vi,
      actions: /* @__PURE__ */ n(f, { disabled: !s, onClick: d, children: a }),
      children: [
        /* @__PURE__ */ l(
          Ke,
          {
            id: "message-type-param",
            label: "Message type and parameter",
            childrenClassName: Ht,
            children: [
              /* @__PURE__ */ l(
                R,
                {
                  value: e,
                  onChange: (k) => i(k.target.value),
                  children: [
                    /* @__PURE__ */ n("option", { value: "note", children: "Note" }),
                    /* @__PURE__ */ n("option", { value: "cc7", children: "Control change" }),
                    /* @__PURE__ */ n("option", { value: "program", children: "Program change" })
                  ]
                }
              ),
              /* @__PURE__ */ n(
                ce,
                {
                  type: "number",
                  className: Kt,
                  value: m,
                  required: !0,
                  min: 0,
                  max: 127,
                  onChange: (k) => {
                    b(k.target.value);
                    const M = Number.parseInt(k.target.value);
                    isNaN(M) || M >= 0 && M <= 127 && c(M);
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ l(
          Ke,
          {
            id: "action-type-param",
            label: "Action type and parameter",
            childrenClassName: r === "switchPage" || r === "switchPreset" ? Ht : qi,
            children: [
              /* @__PURE__ */ l(
                R,
                {
                  value: r,
                  onChange: (k) => h(k.target.value),
                  children: [
                    /* @__PURE__ */ n("option", { value: "switchPreset", children: "Switch to preset" }),
                    /* @__PURE__ */ n("option", { value: "switchPresetPrev", children: "Switch to previous preset" }),
                    /* @__PURE__ */ n("option", { value: "switchPresetNext", children: "Switch to next preset" }),
                    /* @__PURE__ */ n("option", { value: "switchPage", children: "Switch to page" }),
                    /* @__PURE__ */ n("option", { value: "switchPagePrev", children: "Switch to previous page" }),
                    /* @__PURE__ */ n("option", { value: "switchPageNext", children: "Switch to next page" })
                  ]
                }
              ),
              (r === "switchPage" || r === "switchPreset") && /* @__PURE__ */ n(
                ce,
                {
                  type: "number",
                  className: Kt,
                  value: v,
                  required: !0,
                  min: 0,
                  max: 127,
                  onChange: (k) => {
                    g(k.target.value);
                    const M = Number.parseInt(k.target.value);
                    isNaN(M) || M >= 0 && M <= 127 && p(M);
                  }
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Yi = () => {
  const e = O(), t = j(), [r, o] = S("note"), [a, s] = S(null), [i, c] = S("switchPage"), [h, p] = S(null);
  return /* @__PURE__ */ n(
    or,
    {
      inputMessage: r,
      inputParameter: a,
      outputAction: i,
      outputParameter: h,
      submitLabel: "Create",
      canSubmit: a !== null && (i === "switchPage" || i === "switchPreset" ? h !== null : !0),
      onInputMessageChange: o,
      onInputParameterChange: s,
      onOutputActionChange: c,
      onOutputParameterChange: p,
      onSubmit: () => {
        o("note"), s(null), c("switchPage"), p(null), t(
          na([
            e,
            {
              midiMessage: r,
              parameterNumber: a ?? 0,
              event: i,
              eventParameter: h
            }
          ])
        );
      }
    }
  );
};
var Ji = "_1v61w0w0", Wi = "_1v61w0w1";
const ar = ({
  pattern: e,
  port: t,
  submitLabel: r,
  canSubmit: o,
  onPatternChange: a,
  onPortChange: s,
  onSubmit: i
}) => /* @__PURE__ */ n(
  nr,
  {
    className: Ji,
    actions: /* @__PURE__ */ n(f, { disabled: !o, onClick: i, children: r }),
    children: /* @__PURE__ */ l(
      Ke,
      {
        id: "usb-host-assignment",
        label: "Pattern and port",
        childrenClassName: Wi,
        children: [
          /* @__PURE__ */ n(
            ce,
            {
              type: "text",
              required: !0,
              value: e,
              onChange: (c) => a(c.target.value)
            }
          ),
          /* @__PURE__ */ n(rr, { value: t, onChange: s })
        ]
      }
    )
  }
);
var Xi = "tao2y50", Zi = "tao2y51";
const el = () => {
  const e = O(), t = Qo(), r = Sn(), o = j();
  return /* @__PURE__ */ l("div", { className: Xi, children: [
    /* @__PURE__ */ n("strong", { children: "MIDI Control" }),
    r.usbDevToMidiControl ? /* @__PURE__ */ l("span", { children: [
      "Assign MIDI messages to Electra internal commands, such as page and preset switching.",
      /* @__PURE__ */ n("p", { children: "Electra One listens to MIDI Control commands on:" }),
      /* @__PURE__ */ l("ul", { children: [
        /* @__PURE__ */ n("li", { children: "All MIDI interfaces" }),
        /* @__PURE__ */ n("li", { children: `Port ${r.midiControlPort === 2 ? "CTRL" : r.midiControlPort + 1}` }),
        /* @__PURE__ */ n("li", { children: r.midiControlChannel === 0 ? "All MIDI Channels" : "MIDI Channel #" + r.midiControlChannel })
      ] }),
      "You can adjust this settings in the ",
      /* @__PURE__ */ n("strong", { children: "Router" }),
      " page."
    ] }) : /* @__PURE__ */ l("span", { children: [
      "The router is not configured to forward MIDI messages to the MIDI Control. You can enable it in the ",
      /* @__PURE__ */ n("strong", { children: "Router" }),
      " page."
    ] }),
    /* @__PURE__ */ l("ul", { className: Zi, children: [
      t.map((a, s) => /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(
        or,
        {
          inputMessage: a.midiMessage,
          inputParameter: a.parameterNumber,
          outputAction: a.event,
          outputParameter: a.eventParameter,
          submitLabel: "Delete",
          canSubmit: !0,
          onInputMessageChange: (i) => o(
            Pe([
              e,
              [
                s,
                {
                  ...a,
                  midiMessage: i
                }
              ]
            ])
          ),
          onInputParameterChange: (i) => o(
            Pe([
              e,
              [
                s,
                {
                  ...a,
                  parameterNumber: i
                }
              ]
            ])
          ),
          onOutputActionChange: (i) => o(
            Pe([
              e,
              [
                s,
                {
                  ...a,
                  event: i
                }
              ]
            ])
          ),
          onOutputParameterChange: (i) => o(
            Pe([
              e,
              [
                s,
                {
                  ...a,
                  eventParameter: i
                }
              ]
            ])
          ),
          onSubmit: () => o(ra([e, s]))
        }
      ) }, `midi-control-mapping-${s}`)),
      /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(Yi, {}) })
    ] })
  ] });
};
var tl = "_13ow7dz0", nl = "_13ow7dz1";
const rl = () => {
  const e = O(), t = j(), r = pt();
  return /* @__PURE__ */ l("div", { className: tl, children: [
    /* @__PURE__ */ n("strong", { children: "Preset banks" }),
    /* @__PURE__ */ n("span", { children: "A preset bank is a named collection of 12 presets. Electra One has 6 presets banks. You can customize the name and color of each bank below." }),
    /* @__PURE__ */ l("div", { className: nl, children: [
      /* @__PURE__ */ n(I, { color: "shady", children: "Name" }),
      /* @__PURE__ */ n(I, { color: "shady", children: "Color" }),
      /* @__PURE__ */ n(I, { color: "shady", children: "Action" }),
      r.map(({ id: o, name: a, color: s }, i) => /* @__PURE__ */ l(Nr, { children: [
        /* @__PURE__ */ n(
          ce,
          {
            value: a,
            onChange: (c) => t(
              Lt([
                e,
                i,
                { id: o, name: c.target.value, color: s }
              ])
            )
          }
        ),
        /* @__PURE__ */ n(I, { color: "shady", children: /* @__PURE__ */ n(
          Hi,
          {
            value: s,
            onChange: (c) => t(
              Lt([
                e,
                i,
                { id: o, name: a, color: c }
              ])
            )
          }
        ) }),
        /* @__PURE__ */ n(
          f,
          {
            onClick: () => t(sa([e, i])),
            children: "Reset"
          }
        )
      ] }, `preset-bank-details-${o}`))
    ] })
  ] });
};
var ol = "_13uzltl0", al = "_13uzltl1", sl = "_13uzltl2", il = "_13uzltl3";
const ll = () => {
  const e = O(), t = Sn(), r = j();
  return /* @__PURE__ */ l("div", { className: ol, children: [
    /* @__PURE__ */ n("strong", { children: "Default routing set" }),
    /* @__PURE__ */ n("span", { children: "Rules for routing of inbound MIDI messages to output ports of available MIDI interfaces and Message processors." }),
    /* @__PURE__ */ n("div", { className: al, children: /* @__PURE__ */ l("div", { className: sl, children: [
      /* @__PURE__ */ l("div", { className: il, children: [
        /* @__PURE__ */ n(I, { color: "shady", children: "Source interface" }),
        /* @__PURE__ */ n(I, { color: "shady", children: "Port" }),
        /* @__PURE__ */ n(I, { color: "shady", children: "Channel" }),
        /* @__PURE__ */ n(I, { color: "shady", children: "Enabled" }),
        /* @__PURE__ */ n(I, { color: "shady", children: "Destination" }),
        /* @__PURE__ */ n(I, { color: "shady", children: "Post action" })
      ] }),
      /* @__PURE__ */ n(
        Qi,
        {
          port: t.midiControlPort,
          channel: t.midiControlChannel,
          enabled: t.usbDevToMidiControl,
          drop: t.midiControlDrop,
          onPortChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiControlPort: o
              }
            ])
          ),
          onChannelChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiControlChannel: o
              }
            ])
          ),
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                usbDevToMidiControl: o
              }
            ])
          ),
          onDropChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiControlDrop: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "USB Device",
          destination: "MIDI IO",
          enabled: t.usbDevToMidiIo,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                usbDevToMidiIo: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "USB Device",
          destination: "USB Host",
          enabled: t.usbDevToUsbHost,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                usbDevToUsbHost: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "MIDI IO",
          destination: "USB Device",
          enabled: t.midiIoToUsbDev,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiIoToUsbDev: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "MIDI IO",
          destination: "USB Host",
          enabled: t.midiIoToUsbHost,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiIoToUsbHost: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "USB Host",
          destination: "MIDI IO",
          enabled: t.usbHostToMidiIo,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                usbHostToMidiIo: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "USB Host",
          destination: "USB Device",
          enabled: t.usbHostToUsbDev,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                usbHostToUsbDev: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "MIDI IO",
          port: "Port 1",
          destination: "MIDI 1 OUT",
          enabled: t.midiIo1Thru,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiIo1Thru: o
              }
            ])
          )
        }
      ),
      /* @__PURE__ */ n(
        K,
        {
          source: "MIDI IO",
          port: "Port 2",
          destination: "MIDI 2 OUT",
          enabled: t.midiIo2Thru,
          onEnabledChange: (o) => r(
            x([
              e,
              {
                ...t,
                midiIo2Thru: o
              }
            ])
          )
        }
      )
    ] }) })
  ] });
};
var cl = "ic9sw10", se = "ic9sw11";
const dl = () => {
  const e = O(), t = j(), r = Vo();
  return /* @__PURE__ */ l("div", { className: cl, children: [
    /* @__PURE__ */ n("label", { className: se, children: "Active control set visual indicator" }),
    /* @__PURE__ */ l(
      R,
      {
        value: r.activeControlSetType,
        onChange: (o) => t(
          ae([
            e,
            {
              ...r,
              activeControlSetType: o.target.value
            }
          ])
        ),
        children: [
          /* @__PURE__ */ n("option", { value: "none", children: "None" }),
          /* @__PURE__ */ n("option", { value: "dim", children: "Dim" }),
          /* @__PURE__ */ n("option", { value: "bars", children: "Bars" }),
          /* @__PURE__ */ n("option", { value: "background", children: "Background" })
        ]
      }
    ),
    /* @__PURE__ */ n("label", { className: se, children: "Switch active control set (section of active controls) when controls are touched" }),
    /* @__PURE__ */ n(
      Z,
      {
        checked: r.touchSwitchControlSets,
        onChange: (o) => t(
          ae([
            e,
            {
              ...r,
              touchSwitchControlSets: o.target.checked
            }
          ])
        )
      }
    ),
    /* @__PURE__ */ n("label", { className: se, children: "Reset active control set when the page is switched" }),
    /* @__PURE__ */ n(
      Z,
      {
        checked: r.resetActiveControlSet,
        onChange: (o) => t(
          ae([
            e,
            {
              ...r,
              resetActiveControlSet: o.target.checked
            }
          ])
        )
      }
    ),
    /* @__PURE__ */ n("label", { className: se, children: "Save and recall preset values when switching presets" }),
    /* @__PURE__ */ n(
      Z,
      {
        checked: r.keepPresetState,
        onChange: (o) => t(
          ae([
            e,
            {
              ...r,
              keepPresetState: o.target.checked
            }
          ])
        )
      }
    ),
    /* @__PURE__ */ n("label", { className: se, children: "Restore the last saved preset values when Electra One starts up" }),
    /* @__PURE__ */ n(
      Z,
      {
        checked: r.loadPresetStateOnStartup,
        onChange: (o) => t(
          ae([
            e,
            {
              ...r,
              loadPresetStateOnStartup: o.target.checked
            }
          ])
        )
      }
    )
  ] });
}, ul = () => {
  const e = O(), t = j(), [r, o] = S(""), [a, s] = S(0), i = () => {
    o(""), s(0), t(
      oa([
        e,
        {
          pattern: r,
          port: a
        }
      ])
    );
  };
  return /* @__PURE__ */ n(
    ar,
    {
      pattern: r,
      port: a,
      submitLabel: "Create",
      canSubmit: r.length > 0,
      onPatternChange: o,
      onPortChange: s,
      onSubmit: i
    }
  );
};
var hl = "_12v7nv60", pl = "_12v7nv61";
const ml = () => {
  const e = O(), t = Go(), r = j();
  return /* @__PURE__ */ l("div", { className: hl, children: [
    /* @__PURE__ */ n("strong", { children: "USB Host Assignments" }),
    /* @__PURE__ */ l("span", { children: [
      "USB Host assignments allow automatic assignment of MIDI devices connected to the USB host interface to Electra's internal ports.",
      /* @__PURE__ */ n("p", { children: "A string pattern is used to match the product name of USB devices. If the pattern is found within the product name, the device is assigned to the specified port. The matching algorithm is case-insensitive. The first match results in the port assignment, subsequent matches are ignored." })
    ] }),
    /* @__PURE__ */ l("ul", { className: pl, children: [
      t.map((o, a) => /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(
        ar,
        {
          pattern: o.pattern,
          port: o.port,
          submitLabel: "Delete",
          canSubmit: !0,
          onPatternChange: (s) => r(
            Mt([
              e,
              [
                a,
                {
                  ...o,
                  pattern: s
                }
              ]
            ])
          ),
          onPortChange: (s) => r(
            Mt([
              e,
              [
                a,
                {
                  ...o,
                  port: s
                }
              ]
            ])
          ),
          onSubmit: () => r(aa([e, a]))
        }
      ) }, `usb-host-assignment-${a}`)),
      /* @__PURE__ */ n("li", { children: /* @__PURE__ */ n(ul, {}) })
    ] })
  ] });
};
var sr = "_1rcs57s0", ir = "_1rcs57s1", lr = "_1rcs57s2", cr = "_1rcs57s3", gl = "_1rcs57s4", vl = "_1rcs57s5", fl = "_1rcs57s6", yl = "_1rcs57s7 h0eyxr1", Sl = "_1rcs57s8 h0eyxr1";
const Pl = () => /* @__PURE__ */ l("div", { className: sr, children: [
  /* @__PURE__ */ n(ze, { label: "Preset bank" }),
  /* @__PURE__ */ l("figure", { className: ir, children: [
    /* @__PURE__ */ n("figcaption", { className: yl, children: "Preset slots" }),
    B(2, (e) => /* @__PURE__ */ n(
      "ul",
      {
        className: lr,
        children: B(6, (t) => /* @__PURE__ */ n(
          "li",
          {
            className: L([cr, Sl])
          },
          `preset-slot-sidebar-group-${e}-slot-${t + e * 6}`
        ))
      },
      `preset-slot-sidebar-group-${e}`
    ))
  ] })
] }), bl = ({ onChange: e }) => {
  const t = bn(), r = Cn(), [o, a] = S(t), [s, i] = S(r);
  F(() => {
    a(t), i(r);
  }, [t, r]);
  const c = Pn(), h = pt();
  return /* @__PURE__ */ l("div", { className: sr, children: [
    /* @__PURE__ */ n(
      be,
      {
        id: "preset-slot-sidebar-bank",
        label: "Preset bank",
        value: o,
        onChange: (p) => {
          const d = Number.parseInt(p.target.value);
          isNaN(d) || (a(d), i(-1));
        },
        children: B(6, (p) => {
          var d;
          return /* @__PURE__ */ n("option", { value: p, children: ((d = h[p]) == null ? void 0 : d.name) ?? `BANK #${p + 1}` }, `preset-slot-sidebar-bank-${p}`);
        })
      }
    ),
    /* @__PURE__ */ l("figure", { className: ir, children: [
      /* @__PURE__ */ n("figcaption", { children: "Preset slots" }),
      B(2, (p) => /* @__PURE__ */ n(
        "ul",
        {
          className: lr,
          children: B(6, (d) => {
            var m, b, v, g;
            return /* @__PURE__ */ n(
              "li",
              {
                className: L([
                  cr,
                  ((m = c[o]) == null ? void 0 : m[d + p * 6]) !== void 0 && gl,
                  d + p * 6 === s && (((b = c[o]) == null ? void 0 : b[d + p * 6]) !== void 0 ? vl : fl)
                ]),
                onClick: () => {
                  i(d + p * 6), e(o, d + p * 6);
                },
                children: ((g = (v = c[o]) == null ? void 0 : v[d + p * 6]) == null ? void 0 : g.name) ?? "Unused"
              },
              `preset-slot-sidebar-group-${p}-slot-${d + p * 6}`
            );
          })
        },
        `preset-slot-sidebar-group-${p}`
      ))
    ] })
  ] });
}, Cl = ({ onChange: e }) => {
  const t = mt(), r = oe();
  return t ? /* @__PURE__ */ n(Pl, {}) : r ? /* @__PURE__ */ n(bl, { onChange: e }) : null;
};
var zt = "jzgv8o0";
const wl = ({
  onChange: e
}) => {
  const t = mt(), r = oe();
  return t ? /* @__PURE__ */ l("div", { className: zt, children: [
    /* @__PURE__ */ n(ze, { label: "Preset bank" }),
    /* @__PURE__ */ n(ze, { label: "Slot" })
  ] }) : r ? /* @__PURE__ */ n("div", { className: zt, children: /* @__PURE__ */ n(Il, { onChange: e }) }) : /* @__PURE__ */ n("span", {});
}, Il = ({ onChange: e }) => {
  const t = bn(), r = Cn(), [o, a] = S(t), [s, i] = S(r), c = Pn(), h = pt();
  F(() => {
    a(t), i(r);
  }, [t, r]);
  const p = c[o];
  return /* @__PURE__ */ l(_, { children: [
    /* @__PURE__ */ n(
      be,
      {
        id: "preset-bank-select",
        label: "Preset bank",
        value: o,
        onChange: (d) => a(Number.parseInt(d.target.value)),
        children: B(6, (d) => {
          var m;
          return /* @__PURE__ */ n("option", { value: d, children: ((m = h[d]) == null ? void 0 : m.name) ?? `BANK #${d + 1}` }, `preset-bank-option-${d}`);
        })
      }
    ),
    /* @__PURE__ */ l(
      be,
      {
        id: "preset-slot-select",
        label: "Slot",
        value: s,
        onChange: (d) => {
          const m = Number.parseInt(d.target.value);
          i(m), e(o, m);
        },
        children: [
          /* @__PURE__ */ n("option", { value: -1, disabled: !0 }),
          B(12, (d) => {
            var m;
            return /* @__PURE__ */ l("option", { value: d, children: [
              d + 1,
              " - ",
              ((m = p == null ? void 0 : p[d]) == null ? void 0 : m.name) ?? "unused"
            ] }, `preset-slot-option-${d}`);
          })
        ]
      }
    )
  ] });
};
var kl = "jf0yrk0", Nl = "jf0yrk1 _8bvdxh1 _8bvdxh0", Al = "jf0yrk2";
const El = ({
  owner: e,
  project: t,
  onBack: r
}) => {
  const o = Le(), {
    copyProject: a,
    downloadProject: s,
    downloadPreset: i,
    downloadLua: c,
    publish: h,
    uploadPreset: p
  } = Pt(), { legacyEditorUrl: d, showCopy: m } = an(), b = H(), v = oe(), g = e ? d.replace("{projectId}", t.id) : !1;
  return /* @__PURE__ */ l("div", { className: kl, children: [
    /* @__PURE__ */ n(
      f,
      {
        disabled: !v,
        onClick: () => p(t.id, t.name),
        children: "Send to Electra"
      }
    ),
    g && /* @__PURE__ */ l(Lr, { to: g, className: Nl, target: "_blank", children: [
      /* @__PURE__ */ n(Ee, {}),
      "Edit"
    ] }),
    e && /* @__PURE__ */ l(f, { onClick: () => h(t.id, !t.isPublic), children: [
      "Make ",
      t.isPublic ? "unlisted" : "public"
    ] }),
    !e && m && /* @__PURE__ */ n(
      f,
      {
        disabled: o === null,
        onClick: () => a(t.id),
        children: "Copy to your presets"
      }
    ),
    /* @__PURE__ */ l(zr, { children: [
      /* @__PURE__ */ n(f, { onClick: () => s(t.id), children: "Download project" }),
      /* @__PURE__ */ n(
        f,
        {
          disabled: !t.hasPreset,
          onClick: () => i(t.id),
          children: "Download preset"
        }
      ),
      /* @__PURE__ */ n(
        f,
        {
          disabled: !t.hasLua,
          onClick: () => c(t.id),
          children: "Download lua"
        }
      )
    ] }),
    e && /* @__PURE__ */ n(
      f,
      {
        onClick: () => b("confirm-delete", {
          replace: !0
        }),
        children: "Delete"
      }
    ),
    r !== void 0 && /* @__PURE__ */ l(_, { children: [
      /* @__PURE__ */ n("div", { className: Al }),
      /* @__PURE__ */ l(f, { onClick: r, children: [
        /* @__PURE__ */ n(so, {}),
        "Back"
      ] })
    ] })
  ] });
};
var Ml = "u6hg2m0", Ll = "u6hg2m1", Ul = "u6hg2m2", $l = "u6hg2m3", dr = "u6hg2m4";
const jl = (e) => /* @__PURE__ */ l(
  "a",
  {
    ...e,
    className: L(Ml, e.className),
    target: "_blank",
    children: [
      /* @__PURE__ */ n(Ee, { size: 16 }),
      " ",
      e.children
    ]
  }
), Dl = (e) => /* @__PURE__ */ n("img", { ...e, className: L(Ll, e.className) }), X = (e) => /* @__PURE__ */ n("h1", { ...e, className: L($l, e.className) }), xl = (e) => /* @__PURE__ */ n("ul", { ...e, className: L(dr, e.className) }), Bl = (e) => /* @__PURE__ */ n("ol", { ...e, className: L(dr, e.className) }), _l = ({ value: e }) => /* @__PURE__ */ n("div", { className: Ul, children: e === null || e.length === 0 ? /* @__PURE__ */ n("span", { children: "This preset has no description" }) : /* @__PURE__ */ n(
  po,
  {
    components: {
      a: jl,
      img: Dl,
      p: ({ children: r }) => /* @__PURE__ */ n("span", { children: r }),
      h1: X,
      h2: X,
      h3: X,
      h4: X,
      h5: X,
      h6: X,
      ol: Bl,
      ul: xl
    },
    children: e
  }
) });
var Tl = "_1cn8fos0", Ol = "_1cn8fos1", Rl = "_1cn8fos2", Fl = "_1cn8fos3", Hl = "_1cn8fos4", Kl = "_1cn8fos5", zl = "_1cn8fos6", Ql = "_1rofcgh0", Gl = "_1rofcgh1", Vl = "_1rofcgh2", ql = "_1rofcgh3", Yl = "_1rofcgh4", Jl = "_1rofcgh5", Wl = "_1rofcgh6";
const Fe = 6, Xl = () => {
  const e = ve(null), [t, r] = S(-1), o = Q();
  return F(() => {
    if (o)
      return;
    const a = e.current;
    if (a === null)
      return;
    const s = new IntersectionObserver(
      (i) => {
        const c = i.find((p) => p.isIntersecting);
        if (c === void 0)
          return;
        const h = Array.from(a.children).findIndex(
          (p) => p === c.target
        );
        r(h);
      },
      {
        root: a,
        threshold: 0.5
      }
    );
    for (const i of a.children)
      s.observe(i);
    return () => {
      for (const i of a.children)
        s.unobserve(i);
    };
  }, [o]), /* @__PURE__ */ l("div", { className: Ql, children: [
    /* @__PURE__ */ n("ul", { ref: e, className: Gl, children: B(Fe, (a) => /* @__PURE__ */ l(
      "li",
      {
        style: {
          scrollSnapAlign: a === 0 ? "start" : a === Fe - 1 ? "end" : "center"
        },
        children: [
          "Page #",
          a + 1,
          /* @__PURE__ */ n(ct, { src: null, className: Vl, children: /* @__PURE__ */ n("div", { className: ql, children: "Preview missing" }) })
        ]
      },
      `fake-page-${a}`
    )) }),
    !o && /* @__PURE__ */ n("ul", { className: Yl, children: B(Fe, (a) => /* @__PURE__ */ n(
      "li",
      {
        className: L([
          Jl,
          a === t && Wl
        ]),
        onClick: () => {
          if (e.current === null)
            return;
          Array.from(e.current.children)[a].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
          });
        }
      },
      `fake-page-indicator-${a}`
    )) })
  ] });
}, Zl = ({ project: e, onClose: t }) => {
  const r = Le(), [o, { isLoading: a }] = je(
    e.user
  ), s = r !== null && r.id === e.userId;
  return /* @__PURE__ */ l("div", { className: Tl, children: [
    /* @__PURE__ */ l("header", { className: Ol, children: [
      /* @__PURE__ */ l("span", { className: Fl, children: [
        e.name,
        s && (e.isPublic ? /* @__PURE__ */ l("span", { children: [
          /* @__PURE__ */ n(io, {}),
          " Public"
        ] }) : /* @__PURE__ */ l("span", { children: [
          /* @__PURE__ */ n(lo, {}),
          " Unlisted"
        ] }))
      ] }),
      /* @__PURE__ */ n("span", { children: [e.brand, e.type, e.group].filter((i) => i !== null).join(" / ") }),
      /* @__PURE__ */ l("span", { className: Hl, children: [
        /* @__PURE__ */ l("span", { className: Kl, children: [
          /* @__PURE__ */ n(
            ct,
            {
              src: a ? !1 : o,
              className: zl
            }
          ),
          "by ",
          e.user.name ?? e.user.name
        ] }),
        /* @__PURE__ */ l("span", { children: [
          "Last modified:",
          " ",
          we.fromMillis(e.updatedAt).toLocaleString(
            we.DATETIME_MED
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ n(El, { project: e, owner: s, onBack: t }),
    /* @__PURE__ */ l("div", { className: Rl, children: [
      /* @__PURE__ */ n(_l, { value: e.description }),
      /* @__PURE__ */ n(Xl, {})
    ] })
  ] });
}, he = me(null);
he.displayName = "ActionsContext";
const Pt = () => {
  const e = ge(he);
  if (e === null)
    throw new Error(`${he.displayName} is null`);
  return e;
};
var ec = "_8wc64k0", tc = "_8wc64k1", nc = "_8wc64k2", C = /* @__PURE__ */ ((e) => (e.RefreshPublic = "refresh-public", e.RefreshPrivate = "refresh-private", e.SwitchSlot = "switch-slot", e.ClearActiveSlot = "clear-active-slot", e.CopyProject = "copy-project", e.DownloadProject = "download-project", e.DownloadPreset = "download-preset", e.DownloadLua = "download-lua", e.UploadPreset = "upload-preset", e.ImportFromActiveSlot = "import-preset", e.DeleteProject = "delete-project", e.Publish = "publish", e))(C || {});
const Qt = ({
  title: e,
  children: t
}) => {
  var p;
  const r = Se(), o = Q(), s = (p = st().at(-1)) == null ? void 0 : p.pathname;
  if (s === void 0)
    throw new Error("pathname undefined");
  const i = s.endsWith("/") ? s.slice(0, s.length - 1) : s, c = Ae(
    (d, m) => {
      r({
        type: C.SwitchSlot,
        bank: d,
        slot: m,
        referrer: i
      });
    },
    [r, i]
  ), h = T(
    () => ({
      refreshPublic: () => r({
        type: C.RefreshPublic
      }),
      refreshPrivate: () => r({
        type: C.RefreshPrivate
      }),
      switchSlot: c,
      clearActiveSlot: () => r({
        type: C.ClearActiveSlot,
        referrer: i
      }),
      copyProject: (d) => r({
        type: C.CopyProject,
        id: d,
        referrer: i
      }),
      downloadProject: (d) => r({
        type: C.DownloadProject,
        id: d,
        referrer: i
      }),
      downloadPreset: (d) => r({
        type: C.DownloadPreset,
        id: d,
        referrer: i
      }),
      downloadLua: (d) => r({
        type: C.DownloadLua,
        id: d,
        referrer: i
      }),
      importPreset: () => r({
        type: C.ImportFromActiveSlot,
        referrer: i
      }),
      uploadPreset: (d, m) => r({
        type: C.UploadPreset,
        id: d,
        name: m,
        referrer: i
      }),
      deleteProject: (d) => r({
        type: C.DeleteProject,
        id: d
      }),
      publish: (d, m) => r({
        type: C.Publish,
        id: d,
        isPublic: m,
        referrer: i
      })
    }),
    [c, r, i]
  );
  return o ? /* @__PURE__ */ n(_, { children: /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ l("div", { className: ec, children: [
    /* @__PURE__ */ n(he.Provider, { value: h, children: /* @__PURE__ */ l("div", { className: tc, children: [
      t,
      /* @__PURE__ */ n(le, {})
    ] }) }),
    /* @__PURE__ */ n(Cl, { onChange: c })
  ] }) }) }) : /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(ft, { header: e, children: /* @__PURE__ */ n(he.Provider, { value: h, children: /* @__PURE__ */ l("div", { className: nc, children: [
    /* @__PURE__ */ n(wl, { onChange: c }),
    t,
    /* @__PURE__ */ n(le, {})
  ] }) }) }) });
}, at = "private-project", pe = (e) => [
  at,
  e
], Be = 90, bt = (e) => ({
  lastId: void 0,
  filter: e
}), Ct = (e) => (t, r) => {
  var o;
  return t.length < Be ? null : {
    lastId: (o = r.flat().at(-1)) == null ? void 0 : o.id,
    filter: e
  };
}, rc = (e) => {
  const t = E(), r = Na(), o = Wt({
    initialPageParam: bt(e),
    queryKey: pe(e),
    queryFn: ({ pageParam: s }) => t.getPrivateProjectBriefs(
      r.id,
      Be,
      s.lastId,
      s.filter
    ),
    getNextPageParam: Ct(e)
  });
  return [T(() => {
    if (o.data !== void 0)
      return o.data.pages.flatMap((s) => s);
  }, [o.data]), o];
}, oc = "public-project", Ne = (e) => [
  oc,
  e
], _e = 90, wt = (e) => ({
  lastId: void 0,
  filter: e
}), It = (e) => (t, r) => {
  var o;
  return t.length < _e ? null : {
    lastId: (o = r.flat().at(-1)) == null ? void 0 : o.id,
    filter: e
  };
}, ac = (e) => {
  const t = E(), r = Wt({
    initialPageParam: wt(e),
    queryKey: Ne(e),
    queryFn: ({ pageParam: a }) => t.getPublicProjectBriefs(
      _e,
      a.lastId,
      a.filter
    ),
    getNextPageParam: It(e)
  });
  return [T(() => {
    if (r.data !== void 0)
      return r.data.pages.flatMap((a) => a);
  }, [r.data]), r];
}, Gt = (e, t) => async ({ request: r }) => $e(async () => {
  const o = await r.json();
  switch (o.type) {
    case C.RefreshPublic: {
      const a = E(), s = On(u.getState());
      return await e.fetchInfiniteQuery({
        initialPageParam: wt(s),
        queryKey: Ne(s),
        queryFn: ({ pageParam: i }) => a.getPublicProjectBriefs(
          _e,
          i.lastId,
          i.filter
        ),
        getNextPageParam: It(s)
      }), u.dispatch(Ha(s)), null;
    }
    case C.RefreshPrivate: {
      const a = ye(u.getState()), s = E(), i = _n(u.getState());
      return a === null || (await e.fetchInfiniteQuery({
        initialPageParam: bt(i),
        queryKey: pe(i),
        queryFn: ({ pageParam: c }) => s.getPrivateProjectBriefs(
          a.id,
          Be,
          c.lastId,
          c.filter
        ),
        getNextPageParam: Ct(i)
      }), u.dispatch(_a(i))), null;
    }
    case C.SwitchSlot: {
      const [a, s] = ee(
        u.getState()
      );
      return await t.switchToSlot(
        a,
        s,
        o.bank,
        o.slot,
        2e3
      ), u.dispatch(
        Ve([
          z(u.getState()),
          o.slot
        ])
      ), U(o.referrer);
    }
    case C.ClearActiveSlot: {
      const [a, s] = ee(
        u.getState()
      ), { activeBank: i, activeSlot: c } = de(
        u.getState()
      ), h = z(u.getState());
      return await t.clearSlot(
        a,
        s,
        i,
        c,
        1e3
      ), u.dispatch(
        ia([h, i, c])
      ), U(o.referrer);
    }
    case C.CopyProject: {
      const a = E(), s = We(u.getState());
      return await a.copyProject(s.id, o.id), await e.invalidateQueries({
        queryKey: [at]
      }), U(o.referrer);
    }
    case C.UploadPreset: {
      const [a, s] = ee(
        u.getState()
      ), { activeBank: i, activeSlot: c } = de(
        u.getState()
      ), h = z(u.getState()), d = await E().getProject(o.id);
      if (d.preset === null)
        throw new Error("preset was null");
      if (typeof d.preset == "string")
        throw new Error("preset was malformed");
      return await t.sendPreset(a, s, d.preset, 1e4), d.lua !== null && await t.sendLua(a, s, d.lua, 1e4), u.dispatch(
        la([
          h,
          i,
          c,
          o.id,
          o.name
        ])
      ), U(o.referrer);
    }
    case C.DownloadProject: {
      const s = await E().getProject(o.id);
      try {
        const i = new Blob([
          JSON.stringify({
            preset: s.preset,
            files: s.lua !== null ? [
              {
                name: "preset.lua",
                body: s.lua
              }
            ] : []
          })
        ]);
        ie(i, "project.e1proj");
      } catch (i) {
        console.error(i);
      }
      return U(o.referrer);
    }
    case C.DownloadPreset: {
      const s = await E().getProject(o.id);
      try {
        const i = new Blob([
          s.preset !== null ? typeof s.preset != "string" ? JSON.stringify(s.preset, void 0, 2) : s.preset : "{}"
        ]);
        ie(
          i,
          `preset.${typeof s.preset == "string" ? "txt" : "json"}`
        );
      } catch (i) {
        console.error(i);
      }
      return U(o.referrer);
    }
    case C.DownloadLua: {
      const s = await E().getProject(o.id);
      try {
        const i = new Blob([s.lua ?? ""]);
        ie(i, "preset.lua");
      } catch (i) {
        console.error(i);
      }
      return U(o.referrer);
    }
    case C.ImportFromActiveSlot: {
      const [a, s] = ee(
        u.getState()
      ), i = We(u.getState()), c = E(), h = await t.getPreset(a, s, 1e4);
      return await c.createProject(i.id, h.name, h), typeof h.projectId == "string" && await e.invalidateQueries({
        queryKey: xt(h.projectId)
      }), await e.invalidateQueries({
        queryKey: [at]
      }), U(o.referrer);
    }
    case C.DeleteProject: {
      const a = E(), s = Ue(u.getState()), i = pe(s), c = xt(o.id), h = e.getQueryData(i), p = e.getQueryData(c);
      try {
        await e.setQueryData(
          i,
          (d) => ({
            ...d,
            pages: d.pages.map(
              (m) => m.filter((b) => b.id !== o.id)
            )
          })
        ), await e.cancelQueries({
          queryKey: c
        }), await a.deleteProject(o.id);
      } catch (d) {
        console.error(d), await e.setQueryData(
          i,
          h
        ), await e.setQueryData(
          c,
          p
        );
      }
      return null;
    }
    case C.Publish:
      return await E().patchProject(o.id, "isPublic", o.isPublic), U(o.referrer);
  }
}), kt = ({ touch: e }) => {
  const t = zn(), r = H(), { uploadPreset: o } = Pt(), a = oe();
  return /* @__PURE__ */ l(_, { children: [
    e && /* @__PURE__ */ n(f, { onClickCapture: () => r(`project/${t.id}`), children: "Details" }),
    /* @__PURE__ */ n(
      f,
      {
        disabled: !a,
        onClick: () => o(t.id, t.name),
        children: "Send to Electra"
      }
    )
  ] });
}, ur = () => /* @__PURE__ */ n(kt, { touch: !0 }), sc = () => {
  const e = Ta(), t = Oa(), r = j(), o = Se(), a = H(), [s, { hasNextPage: i, isFetching: c, fetchNextPage: h }] = rc(t), p = (d) => {
    r(Ba(d)), o({ type: C.RefreshPrivate });
  };
  return W("My projects"), /* @__PURE__ */ n(
    Zn,
    {
      data: s,
      filter: e,
      isLoadingMore: c,
      hasMore: i,
      gridActions: kt,
      listActions: ur,
      onLoadMore: () => void h(),
      onFilterChange: p,
      onItemClick: (d) => a(`project/${d}`)
    }
  );
}, ic = () => {
  const { projectId: e } = Ur(), t = H(), { deleteProject: r } = Pt(), o = () => t("..", { replace: !0 });
  return /* @__PURE__ */ n(tn, { onClick: o, children: /* @__PURE__ */ l(nn, { children: [
    /* @__PURE__ */ n(rn, { children: "Confirm delete" }),
    /* @__PURE__ */ l("span", { children: [
      "You are about to delete a project. This operation is",
      " ",
      /* @__PURE__ */ n("strong", { children: "irreversible" }),
      "."
    ] }),
    /* @__PURE__ */ l(on, { children: [
      /* @__PURE__ */ n(f, { onClick: () => r(e), children: "Delete" }),
      /* @__PURE__ */ n(f, { onClick: o, children: "Cancel" })
    ] })
  ] }) });
}, lc = (e) => async () => {
  const t = ye(u.getState()), r = Ue(u.getState()), o = E();
  return t === null || e.getQueryData(pe(r)) === void 0 && await e.fetchInfiniteQuery({
    initialPageParam: bt(r),
    queryKey: pe(r),
    queryFn: ({ pageParam: a }) => o.getPrivateProjectBriefs(
      t.id,
      Be,
      a.lastId,
      a.filter
    ),
    getNextPageParam: Ct(r)
  }), null;
};
var cc = "_1b5522o0";
const Vt = () => {
  const e = $r(), t = H();
  return /* @__PURE__ */ l("div", { className: cc, children: [
    /* @__PURE__ */ n(Zl, { project: e, onClose: () => t("..") }),
    /* @__PURE__ */ n(le, {})
  ] });
}, qt = async ({ params: e }) => {
  const t = e.projectId;
  if (t === void 0)
    throw new Error("projectId missing");
  return await E().getProjectBrief(t);
}, dc = () => {
  const e = za(), t = Qa(), r = j(), o = Se(), a = H(), [s, { hasNextPage: i, isFetching: c, fetchNextPage: h }] = ac(t), p = (d) => {
    r(Fa(d)), o({
      type: C.RefreshPublic
    });
  };
  return W("Public projects"), /* @__PURE__ */ n(
    Zn,
    {
      data: s,
      filter: e,
      isLoadingMore: c,
      hasMore: i,
      gridActions: kt,
      listActions: ur,
      onLoadMore: () => void h(),
      onFilterChange: p,
      onItemClick: (d) => a(`project/${d}`)
    }
  );
}, uc = (e) => async () => {
  const t = Ue(u.getState()), r = E();
  return e.getQueryData(Ne(t)) === void 0 && await e.fetchInfiniteQuery({
    initialPageParam: wt(t),
    queryKey: Ne(t),
    queryFn: ({ pageParam: o }) => r.getPublicProjectBriefs(
      _e,
      o.lastId,
      o.filter
    ),
    getNextPageParam: It(t)
  }), null;
};
var hc = "_1aw8e6p0";
const pc = () => (W("Login"), /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ l(jr, { method: "post", className: hc, children: [
  /* @__PURE__ */ n(xe, { always: !0, children: "Login" }),
  /* @__PURE__ */ n(
    At,
    {
      id: "login-username",
      label: "Username",
      type: "email",
      name: "username"
    }
  ),
  /* @__PURE__ */ n(
    At,
    {
      id: "login-password",
      label: "Password",
      type: "password",
      name: "password"
    }
  ),
  /* @__PURE__ */ n(f, { type: "submit", children: "Login" })
] }) })), mc = async ({ request: e }) => {
  const t = await e.formData(), r = t.get("username"), o = t.get("password");
  if (typeof r != "string" || typeof o != "string")
    throw new Error(
      "username or password not a string, this should not happen"
    );
  try {
    return await vr(Dn(), r, o), U("/librarian/private-projects");
  } catch (a) {
    console.error(a);
  }
  return null;
}, gc = () => ye(u.getState()) !== null ? U("/preset-library/private") : null, vc = async () => {
  try {
    return await fr(Dn()), U("/librarian/public-projects");
  } catch (e) {
    console.error(e);
  }
  return null;
}, fc = (e) => ({
  type: "execute-lua",
  data: e
}), yc = (e) => ({
  type: "set-log-level",
  logLevel: e
}), Sc = () => ({
  type: "export-logs"
}), Pc = () => {
  const e = Se(), t = j(), r = Xo(), o = O();
  return W("Lua console"), /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(ft, { header: "Lua console", children: /* @__PURE__ */ n(
    mo,
    {
      entries: r,
      onClearAll: () => t(da(o)),
      onExportAll: () => e(Sc()),
      onLogLevelChange: (a) => e(yc(a)),
      onExecuteLua: (a) => e(fc(a))
    }
  ) }) });
}, bc = (e) => async ({ request: t }) => $e(async () => {
  const r = await t.json();
  switch (r.type) {
    case "execute-lua": {
      const [o, a] = ee(
        u.getState()
      );
      await e.executeLua(o, a, r.data, 1e3);
      break;
    }
    case "set-log-level": {
      const [o, a] = ee(
        u.getState()
      );
      await e.setLogLevel(o, a, r.logLevel, 1e3);
      break;
    }
    case "export-logs": {
      const o = yn(u.getState()), a = new Blob(
        o.map(
          (s) => [
            we.fromMillis(s.timestamp).toFormat("HH:mm:ss.SSS"),
            s.data,
            `
`
          ].join(" ")
        ),
        {
          type: "text/plain"
        }
      );
      ie(a, "logs.txt");
    }
  }
  return null;
}), Cc = (e, t) => ({
  type: "open-input",
  id: e,
  portCode: t
}), wc = (e) => ({
  type: "open-output",
  id: e
}), Ic = () => ({
  type: "export-messages"
}), kc = (e) => ({
  type: "send-midi",
  data: e
}), Nc = () => {
  const e = Se(), t = j(), r = pa(), o = wn(), a = In(), s = ua(), i = ha();
  return W("MIDI console"), /* @__PURE__ */ n(Y, { children: /* @__PURE__ */ n(ft, { header: "MIDI console", children: /* @__PURE__ */ n(
    go,
    {
      messages: r,
      inputs: s,
      output: i,
      inputPorts: o,
      outputPorts: a,
      onClearAll: () => t(ga()),
      onExportAll: () => e(Ic()),
      onInputChange: (c, h) => e(Cc(h, c)),
      onOutputChange: (c) => e(wc(c)),
      onSendMidi: (c) => e(kc([c]))
    }
  ) }) });
}, Ac = (e) => async ({ request: t }) => $e(async () => {
  const r = await t.json();
  switch (r.type) {
    case "open-input": {
      const a = vt(u.getState())[r.portCode];
      a !== null && await u.dispatch(
        En({
          communication: e,
          id: a,
          portCode: r.portCode
        })
      ), r.id !== null && await u.dispatch(
        Nn({
          communication: e,
          id: r.id,
          portCode: r.portCode
        })
      );
      break;
    }
    case "open-output": {
      const o = qe(u.getState());
      o !== null && await u.dispatch(
        Mn({
          communication: e,
          id: o
        })
      ), r.id !== null && await u.dispatch(
        An({
          communication: e,
          id: r.id
        })
      );
      break;
    }
    case "export-messages": {
      const o = Ln(u.getState()), a = new Blob(
        o.map(
          (s) => [
            we.fromMillis(s.timestamp).toFormat("HH:mm:ss.SSS"),
            s.rawData.reduce((i, c) => (i += ` ${vo(c)}`, i), "").trimStart(),
            `
`
          ].join(" ")
        ),
        {
          type: "text/plain"
        }
      );
      ie(a, "messages.txt");
      break;
    }
    case "send-midi": {
      const o = qe(u.getState());
      for (const a of r.data) {
        const s = sn(a);
        try {
          o !== null && await e.sendData(
            o,
            Uint8Array.from(a)
          );
        } catch (i) {
          console.error(i);
        }
        u.dispatch(
          Un([
            {
              ...s,
              direction: "out",
              portCode: null,
              timestamp: Date.now()
            }
          ])
        );
      }
    }
  }
  return null;
});
var Ec = "n8r5y00";
const Mc = (e) => e instanceof Error ? JSON.stringify(
  {
    name: e.name,
    message: e.message,
    cause: e.cause,
    stack: e.stack
  },
  void 0,
  2
) : JSON.stringify(e, void 0, 2), Lc = () => {
  const e = Dr();
  return e != null && console.error(e), /* @__PURE__ */ l("div", { className: Ec, children: [
    /* @__PURE__ */ l("header", { children: [
      /* @__PURE__ */ n(St, { color: "secondary" }),
      "Something went wrong"
    ] }),
    /* @__PURE__ */ l("span", { children: [
      "The Electra One App crashed. Please try to reload the page. It would be a great help if you could report this issue on the Electra One",
      " ",
      /* @__PURE__ */ n("a", { href: "https://forum.electra.one/", children: "forum" }),
      "."
    ] }),
    /* @__PURE__ */ n("strong", { children: "Below is some additional information about the crash:" }),
    /* @__PURE__ */ n("pre", { children: Mc(e) })
  ] });
}, Uc = () => {
  const [e, t] = S(null);
  return /* @__PURE__ */ l(Qr.Provider, { value: e, children: [
    /* @__PURE__ */ n(Va, {}),
    /* @__PURE__ */ n(Si, { children: /* @__PURE__ */ n(le, {}) }),
    /* @__PURE__ */ n("div", { ref: (r) => t(r) })
  ] });
}, $c = (e, t) => xr([
  {
    path: "/",
    element: /* @__PURE__ */ n(Uc, {}),
    errorElement: /* @__PURE__ */ n(Lc, {}),
    children: [
      {
        index: !0,
        element: /* @__PURE__ */ n(Br, { to: "/librarian/public-projects", replace: !0 })
      },
      {
        path: "librarian",
        children: [
          {
            id: $.PublicProjects,
            path: "public-projects",
            loader: uc(e),
            action: Gt(e, t),
            element: /* @__PURE__ */ n(Qt, { title: "Public projects", children: /* @__PURE__ */ n(dc, {}) }),
            children: [
              {
                path: "project/:projectId",
                element: /* @__PURE__ */ n(Vt, {}),
                loader: qt
              }
            ]
          },
          {
            id: $.PrivateProjects,
            path: "private-projects",
            loader: lc(e),
            action: Gt(e, t),
            element: /* @__PURE__ */ n(Qt, { title: "My projects", children: /* @__PURE__ */ n(
              ba,
              {
                fallback: /* @__PURE__ */ n(_s, {}),
                children: /* @__PURE__ */ n(sc, {})
              }
            ) }),
            children: [
              {
                path: "project/:projectId",
                children: [
                  {
                    path: "",
                    element: /* @__PURE__ */ n(Vt, {}),
                    loader: qt,
                    children: [
                      {
                        path: "confirm-delete",
                        element: /* @__PURE__ */ n(ic, {})
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: $.ControllerSettings,
        path: "controller-settings",
        element: /* @__PURE__ */ n(ji, {}),
        loader: xi(t),
        action: Di(t),
        children: [
          {
            id: y.Router,
            path: "router",
            element: /* @__PURE__ */ n(ll, {})
          },
          {
            id: y.MidiControl,
            path: "midi-control",
            element: /* @__PURE__ */ n(el, {})
          },
          {
            id: y.UsbHost,
            path: "usb-host",
            element: /* @__PURE__ */ n(ml, {})
          },
          {
            id: y.UserInterface,
            path: "ui",
            element: /* @__PURE__ */ n(dl, {})
          },
          {
            id: y.PresetBanks,
            path: "preset-banks",
            element: /* @__PURE__ */ n(rl, {})
          }
        ]
      },
      {
        id: $.ControllerInfo,
        path: "controller-info",
        element: /* @__PURE__ */ n(Ni, {})
      },
      {
        id: $.LuaConsole,
        path: "lua-console",
        element: /* @__PURE__ */ n(Pc, {}),
        action: bc(t)
      },
      {
        id: $.MidiConsole,
        path: "midi-console",
        element: /* @__PURE__ */ n(Nc, {}),
        action: Ac(t)
      },
      {
        id: $.Login,
        path: "login",
        element: /* @__PURE__ */ n(pc, {}),
        loader: gc,
        action: mc
      },
      {
        path: "logout",
        action: vc
      }
    ]
  }
]), A = new Vr(), Yt = (e, t, r) => [
  e.map((o) => {
    for (const a of r) {
      if (a[1].input === o.id)
        return {
          id: o.id,
          name: `${a.serial} PORT 1`
        };
      if (a[2].input === o.id)
        return {
          id: o.id,
          name: `${a.serial} PORT 2`
        };
      if (a.ctrl.input === o.id)
        return {
          id: o.id,
          name: `${a.serial} CTRL`
        };
    }
    return o;
  }),
  t.map((o) => {
    for (const a of r) {
      if (a[1].output === o.id)
        return {
          id: o.id,
          name: `${a.serial} PORT 1`
        };
      if (a[2].output === o.id)
        return {
          id: o.id,
          name: `${a.serial} PORT 2`
        };
      if (a.ctrl.output === o.id)
        return {
          id: o.id,
          name: `${a.serial} CTRL`
        };
    }
    return o;
  })
], Zc = (e, t, r) => {
  as(e), Ma(t), A.addPortChangeListener(() => {
    const c = A.getInputPorts(), h = A.getOutputPorts();
    u.dispatch(
      Oe(
        Yt(
          c,
          h,
          Me(u.getState())
        )
      )
    );
  }), (async () => {
    try {
      u.dispatch(Et(!0)), window.addEventListener("beforeunload", (g) => {
        A.removeListeners(), g.returnValue = "";
      }), await A.ensurePermission();
      const c = A.getInputPorts(), h = A.getOutputPorts(), p = await A.discoverElectras(1e3);
      if (console.log("discovered electras", p), p.length > 0) {
        u.dispatch(
          Oe(Yt(c, h, p))
        ), u.dispatch(ea(p)), u.dispatch(kn(0));
        for (let g = 0; g < p.length; g++) {
          const w = p[g];
          if (!(w.ctrl.input === null || w.ctrl.output === null))
            try {
              await A.openInput(w.ctrl.input, 1e3), await A.openOutput(w.ctrl.output, 1e3), await u.dispatch(
                ht({
                  communication: A,
                  index: g,
                  input: w.ctrl.input,
                  output: w.ctrl.output
                })
              ), await u.dispatch(
                Qe({
                  communication: A,
                  index: g,
                  input: w.ctrl.input,
                  output: w.ctrl.output
                })
              );
              const D = [];
              let k = !1;
              const M = () => {
                D.length > 0 && (u.dispatch(ca([g, D])), D.splice(0, D.length)), k = !1;
              };
              A.addInputMessageListener(
                w.ctrl.input,
                ({ message: N, timestamp: hr }) => {
                  switch (N.type) {
                    case "preset-switch": {
                      u.dispatch(Ut([g, N.bank])), u.dispatch(Ve([g, N.slot]));
                      break;
                    }
                    case "preset-bank-switch": {
                      u.dispatch(Ut([g, N.bank])), u.dispatch(Ve([g, -1]));
                      break;
                    }
                    case "preset-list-change": {
                      u.dispatch(
                        Qe({
                          communication: A,
                          index: g,
                          input: w.ctrl.input,
                          output: w.ctrl.output
                        })
                      );
                      break;
                    }
                    case "log": {
                      const Nt = N.data.startsWith("lua: ");
                      D.push({
                        data: Nt ? N.data.substring(5) : N.data,
                        timestamp: hr,
                        lua: Nt
                      }), k || (k = !0, window.setTimeout(M, 100));
                      break;
                    }
                    case "nack":
                      console.warn(`nack received from electra with index ${g}`);
                      break;
                  }
                }
              );
            } catch (D) {
              console.warn("something went wrong ", D);
            }
        }
      } else
        u.dispatch(Oe([c, h]));
      let d = !1;
      const m = [], b = () => {
        m.length > 0 && (u.dispatch(Un(m)), m.splice(0, m.length)), d = !1;
      }, v = ({
        portId: g,
        message: w,
        timestamp: D
      }) => {
        const k = vt(u.getState()), M = Object.entries(k).find(
          ([, N]) => N === g
        );
        M !== void 0 && (m.push({
          ...sn(Array.from(w.rawData)),
          direction: "in",
          timestamp: D,
          portCode: M[0]
        }), d || (d = !0, window.setTimeout(b, 100)));
      };
      for (const g of c)
        A.addInputMessageListener(g.id, v);
    } finally {
      u.dispatch(Et(!1));
    }
  })(), (async () => {
    try {
      u.dispatch($t(!0)), yr(t, (c) => {
        if (c !== null) {
          if (c.email === null)
            throw new Error("user email is null, this should not happen");
          u.dispatch(
            wa({
              id: c.uid,
              name: c.displayName,
              email: c.email
            })
          );
        } else
          u.dispatch(Ia());
      }), await t.authStateReady();
    } finally {
      u.dispatch($t(!1));
    }
  })();
  const s = new mr(), i = $c(s, A);
  return () => /* @__PURE__ */ n(Yr.Provider, { value: r, children: /* @__PURE__ */ n(qr.Provider, { value: A, children: /* @__PURE__ */ n(Pr, { store: u, children: /* @__PURE__ */ n(gr, { client: s, children: /* @__PURE__ */ n(Ea, { router: i }) }) }) }) });
};
var ed = "kgmbg30";
export {
  A as communication,
  ed as defaultThemeClassName,
  E as getElectraStorage,
  as as initializeElectraStorage,
  Zc as makeApp
};
//# sourceMappingURL=index.js.map
